// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T23:15:37.720Z
// Property: Copper Stone (ID: 6767906449167194)
// Collections: 17 amenities, 4 floorplans (live), 25 photos, 77 POIs, 1 reviews, 4 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167194",
  "property_external_id": "785454",
  "property_zillow_url": "https://www.zillow.com/apartments/colorado-springs-co/copper-stone/5XhvZn/",
  "property_apartments_url": "https://www.apartments.com/copperstone-colorado-springs-co/zndjmmz/",
  "property_google_business_url": "https://www.google.com/maps/place/Copper+stone/data=!4m2!3m1!1s0x0:0x79a10c6681849563?sa=X&ved=2ahUKEwig7-jc9oOTAxW3mmoFHV6oCYIQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47727335712",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "copper-stone",
  "property_name": "Copper Stone",
  "property_website_url": "https://www.copperstoneapartmenthomes.com",
  "property_domain": "https://www.copperstoneapartmenthomes.com",
  "property_address": "2827 E Pikes Peak Ave",
  "property_full_address": "2827 E Pikes Peak Ave, Colorado Springs, CO 80909",
  "property_address_1": "2827 E Pikes Peak Ave",
  "property_address_2": null,
  "property_address_city": "Colorado Springs",
  "property_address_state": "CO",
  "property_address_zip_full": null,
  "property_address_zip": "80909",
  "property_address_country": "US",
  "property_address_county": "El Paso County",
  "property_neighborhood_address": "Southeast Colorado Springs",
  "property_address_latitude": "38.8322502",
  "property_address_longitude": "-104.7746102",
  "property_email": "copperstone@weidner.com",
  "property_phone": "7198737945",
  "property_call_tracking_phone": "719-426-3526",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Relaxed, elegant living in Park Hill.</strong> Copper Stone Apartment Homes pairs modern apartments with everyday convenience, a warm community feel, pet-friendly living, free on-site parking, and easy access to public transportation and I-25.</p>",
  "property_long_description": "Come home to relaxed, elegant living at Copper Stone Apartment Homes. Our apartments in Colorado Springs's Park Hill neighborhood are in a vibrant area near the Schriever Air force Base, Citadel Mall, and Memorial Park. Copper Stone offers modern apartments with useful amenities in a warm and active community. It's also pet-friendly, offers free on-site parking, and provides easy access to public transportation and I-25.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/01a16cb2-47c5-767c-b606-f9c1e424da9a.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with a couch, coffee table, and balcony access.",
    "public_id": "01a16cb2-47c5-767c-b606-f9c1e424da9a",
    "storage_key": "property/6767906449167194/01a16cb2-47c5-767c-b606-f9c1e424da9a.webp",
    "width": 2560,
    "height": 1709
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "124",
  "property_year_built": "1964",
  "property_year_renovated": null,
  "property_walk_score": "71",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.96774193548387",
  "property_admin_fee": "200",
  "property_application_fee": "25",
  "property_fees_deposit_info": "Security deposit: $500 (refundable)",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "50",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://copperstoneapartmenthomes.securecafe.com/onlineleasing/copperstone/floorplans.aspx",
  "property_resident_portal_url": "https://copperstoneapartmenthomes.securecafenet.com/residentservices/copperstone/userlogin",
  "property_apply_now_url": "https://copperstoneapartmenthomes.securecafe.com/onlineleasing/copperstone/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019ff2e8-6a51-7586-8192-0bc01bffaa91.webp",
  "property_primary_logo_media": {
    "alt_text": "Copper Stone Apartment Homes logo",
    "public_id": "019ff2e8-6a51-7586-8192-0bc01bffaa91",
    "storage_key": "property/6767906449167194/019ff2e8-6a51-7586-8192-0bc01bffaa91.webp",
    "width": 308,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019ff2e8-a810-746f-9a8b-3c9035153599.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019ff2e8-a810-746f-9a8b-3c9035153599",
    "storage_key": "property/6767906449167194/019ff2e8-a810-746f-9a8b-3c9035153599.webp",
    "width": 308,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019ff2e8-9c67-77c7-9a16-538bc5aebd7a.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019ff2e8-9c67-77c7-9a16-538bc5aebd7a",
    "storage_key": "property/6767906449167194/019ff2e8-9c67-77c7-9a16-538bc5aebd7a.webp",
    "width": 308,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#a85c36",
  "property_secondary_color": "#6b3a22",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#c9a184",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "500 - 970",
  "property_sqft_min": "500",
  "property_sqft_max": "970",
  "property_price_range": "852 - 1995",
  "property_price_min": "852",
  "property_price_max": "1995",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/CopperStoneApartmentsCOSprings",
  "property_instagram_url": "https://www.instagram.com/weidnerapartmenthomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJT-PtmMpFE4cRY5WEgWYMoXk",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Copper Stone",
  "property_home_romance_title": "Relaxed living in Park Hill",
  "property_home_amenities_blurb": "<p><strong>Everyday ease, with space to unwind.</strong> Copper Stone keeps routines simple with covered parking, on-site management, 24-hour availability, courtesy patrol, and a smoke-free setting. Recharge by the outdoor pool, enjoy planned social activities, or head to the dog park with your pet. Inside, air conditioning, Energy Star certified appliances, generous closets, and a private patio or balcony add comfort where it counts.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find your fit at Copper Stone.</strong> Explore studio, one-bedroom, and two-bedroom apartments with open-concept layouts, large windows, spacious closets, and private patios or balconies. Select homes include one-, one-and-a-half-, or two-bath designs, with everyday essentials like Energy Star-certified appliances, dishwashers, microwaves, and air conditioning built in.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture Copper Stone in full color.</strong> Preview bright interiors with oversized windows, granite-topped kitchens, modern appliances, and patios or balconies with fresh-air appeal and available mountain views. Then look outside to the pool, leafy courtyards, dog-friendly play area, and everyday conveniences that bring the community into focus.</p>",
  "property_home_neighborhood_blurb": "<p>Copper Stone sits in vibrant Park Hill, close to the buzz of downtown and mere moments from trails, shops, and dining. Step outside and you're just minutes from the open spaces of Memorial Park, the shopping at Citadel Mall, and convenient commuting via I-25. With Schriever Space Force Base nearby and easy public transportation options, this community truly puts you at the center of Colorado Springs living.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have great things to say about Copper Stone.</strong> Reviews point to kind, compassionate service that makes everyday apartment living feel easier, with special shoutouts for team members like Ms. Jamie, described as “absolutely amazing.” Read more firsthand feedback to see why Copper Stone earns recommendations in Southeast Colorado Springs.</p>",
  "property_neighborhood_blurb": "<p>Park Hill is the heart of Colorado Springs life, blending city energy with outdoor escapes. At Copper Stone, you're just minutes from Memorial Park's green spaces and lakeside paths. Spend weekends exploring shops at Citadel Mall, sampling favorite bites nearby, or hopping on I-25 for easy commutes. Big local employers, including Schriever Space Force Base, make the area ideal for work and play. Public transportation and walking paths connect you easily across the city - come see what thriving Park Hill living feels like at Copper Stone.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Discover a blend of convenient community perks and comforting in-home essentials at Copper Stone Apartments in Colorado Springs, CO. Community amenities like a dog park, pool, and covered parking make outdoor living enjoyable, while in-home features such as air conditioning and walk-in closets invite you to lounge, organize, and recharge with ease. Explore your new routine, indoors and out.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at Copper Stone.</strong> Enjoy relaxed, elegant apartment living in Colorado Springs’s Park Hill neighborhood, with modern spaces, useful comforts, and a warm, active community. Apply online today and take the next step toward calling Copper Stone home.</p>",
  "property_contactus_blurb": "<p>Connect with Copper Stone Apartments in Colorado Springs, CO to learn more about available apartments, schedule a tour, or chat with a member of our leasing team. We're here to help with all your questions and help you find the right home.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Copper Stone?</strong> Start here for quick answers about the community, leasing, amenities, pet-friendly living, parking, and everyday details. If you don’t see what you need, the leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p>Your search for apartments for rent in Colorado Springs, CO ends with Copper Stone. Choose from stunning studio, one-bedroom, or two-bedroom layouts that give you room for peaceful evenings, entertaining, or working from home. Each space offers thoughtful storage, a welcoming feel, and personal touches that make everyday living more comfortable.</p>",
  "property_gallery_blurb": "<p>Step into the inviting world of Copper Stone. Browse images of stylish kitchens, bright living rooms, and outdoor spots perfect for sunny days or quiet evenings. See how everyday comforts and community perks come alive, from the pool to the pet-friendly areas. Picture yourself making memories and feeling right at home in Colorado Springs, CO.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Copper Stone on the map.</strong> See available apartments in Colorado Springs’s Park Hill neighborhood, then look around nearby shopping, parks, transit access, and I-25 connections to get a clearer feel for the area.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living with room for daily rituals.</strong> At Copper Stone, your pet’s routine can be as easy as yours—from quick trips to the on-site dog park to quiet afternoons on your patio or balcony. Inside, open layouts, air conditioning, and spacious closets help keep toys, leashes, beds, and everyday essentials comfortably in place.</p><p>Whether you’re heading out for a walk in Southeast Colorado Springs or winding down after a busy day, Copper Stone keeps pet life simple with green outdoor spaces, practical apartment features, and a community designed for everyday convenience. Review the policy details below, then explore the <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the spaces in person.</p>",
  "property_referafriend_blurb": "<p><strong>Share Copper Stone with a friend.</strong><br>Love the relaxed, elegant feel, modern apartments, pet-friendly setting, free on-site parking, and easy access around Colorado Springs? Invite a friend to discover the warm, active community you call home.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Copper Stone</strong><br>Enjoy simple account management from a community designed for relaxed, elegant living. Log in to pay rent, submit maintenance requests, and stay connected to your Copper Stone Apartment Homes account.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying about Copper Stone.</strong> Feedback highlights the kind, compassionate service that helps daily life feel easier. One resident shared that they “absolutely love it” and gave special praise to Ms. Jamie, calling her “absolutely amazing.”</p><p>As you explore the reviews, you’ll find firsthand impressions of Copper Stone in Southeast Colorado Springs, including what makes the team memorable and why a resident says they would “definitely recommend Copperstone Apartments.”</p>",
  "property_created_at": "1771538443259",
  "property_scheduletour_blurb": "<p>Ready to see Copper Stone up close? Book your in-person or virtual tour to explore spacious studio, one-bedroom, and two-bedroom apartments, the resident lounge, and the pet-friendly dog park. Choose the tour type that suits you best. Our leasing team is here to help, whether onsite or online. Touring restrictions may apply.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out to Copper Stone.</strong> We’ve received your inquiry, and the leasing team will follow up soon. In the meantime, picture relaxed, elegant living in Colorado Springs’s Park Hill neighborhood, with modern apartments, useful amenities, pet-friendly spaces, and a warm, active community to come home to.</p>",
  "property_virtualtours_blurb": "<p>Imagine your daily routine at Copper Stone, from relaxing in spacious living areas to enjoying views of Colorado Springs. Our virtual tour shows you around each floor plan and lets you explore the atmosphere from wherever you are. Get a sense of the community's welcoming energy, room layouts, and what life could look like - all from your own screen. When you're ready, schedule an in-person visit to see how it feels in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Copper Stone",
  "property_seo_title_home": "Comfortable Apartments | Copper Stone | Colorado Springs, CO",
  "property_seo_description_home": "One price, no hidden fees. Pet-friendly Copper Stone offers modern apartments, amenities, and easy access to I-25 in Colorado Springs, CO.",
  "property_seo_title_floorplans": "Floor Plans | Copper Stone | Colorado Springs, CO",
  "property_seo_description_floorplans": "Explore studio, one, and two bedroom apartments at Copper Stone in Colorado Springs, CO - each with modern layouts and flexible options tailored to you.",
  "property_seo_title_amenities": "Amenities | Copper Stone | Colorado Springs, CO",
  "property_seo_description_amenities": "Enjoy an on-site dog park, pool, covered parking, and elegant in-home features at Copper Stone Apartments in Colorado Springs, CO.",
  "property_seo_title_gallery": "Photo Gallery | Copper Stone | Colorado Springs, CO",
  "property_seo_description_gallery": "See images of Copper Stone's modern apartments, pool, and pet-friendly spaces in Colorado Springs, CO. Imagine your new life here.",
  "property_seo_title_virtualtours": "Virtual Tour | Copper Stone | Colorado Springs, CO",
  "property_seo_description_virtualtours": "Explore Copper Stone Apartments virtually and get a feel for layouts, ambiance, and lifestyle before you visit in Colorado Springs, CO.",
  "property_seo_title_interactivemap": "Interactive Map | Copper Stone Apartments",
  "property_seo_description_interactivemap": "Discover your dream home at Copper Stone, Colorado Springs! Use our interactive map to explore floor plans and top amenities today!",
  "property_seo_title_neighborhood": "Park Hill Neighborhood | Copper Stone | Colorado Springs, CO",
  "property_seo_description_neighborhood": "Copper Stone Apartments in Park Hill, Colorado Springs, CO - steps from Memorial Park, Citadel Mall, shopping, and public transit.",
  "property_seo_title_contact": "Contact Copper Stone Apartments | Colorado Springs, CO",
  "property_seo_description_contact": "Reach out to the Copper Stone Apartments team in Colorado Springs for leasing info, tours, and community questions.",
  "property_seo_title_faqs": "FAQs | Apartments in Colorado Springs, CO",
  "property_seo_description_faqs": "Have questions about Copper Stone? Our FAQs cover amenities, pet policies, and more! Discover the Colorado Springs lifestyle today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Colorado Springs, CO",
  "property_seo_description_reviews": "Uncover resident insights at Copper Stone in Colorado Springs! Enjoy modern amenities, spacious floor plans, and a vibrant community. Join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Colorado Springs, CO",
  "property_seo_description_applynow": "Find your perfect retreat at Copper Stone in Colorado Springs! From stylish studios to spacious two-bedrooms, enjoy amenities like a pool, dog park, and more!",
  "property_seo_title_residentaccess": "Resident Access | Copper Stone",
  "property_seo_description_residentaccess": "Welcome to Copper Stone! Log in to your resident portal for easy rent payments, maintenance requests, and exclusive community updates—all at your fingertips!",
  "property_seo_title_referafriend": "Refer A Friend | Copper Stone",
  "property_seo_description_referafriend": "Refer a friend to Copper Stone in Colorado Springs! Great friends make great neighbors—share the joy of luxury living and build your dream community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Copper Stone | Colorado Springs, CO",
  "property_seo_description_scheduletour": "Explore Copper Stone Apartments in Colorado Springs, CO - book an in-person or virtual tour and discover comfort and flexibility.",
  "property_seo_title_privacy": "Privacy Policy | Copper Stone",
  "property_seo_description_privacy": "Your privacy matters at Copper Stone! Dive into our privacy policy to learn how we protect your information in beautiful Colorado Springs.",
  "property_seo_title_accessibility": "Website Accessibility | Copper Stone",
  "property_seo_description_accessibility": "At Copper Stone in Colorado Springs, we prioritize inclusivity and accessibility for a seamless, welcoming living experience!",
  "property_seo_title_sitemap": "Sitemap | Copper Stone",
  "property_seo_description_sitemap": "Navigate Copper Stone in Colorado Springs with ease! Check out our sitemap for a seamless journey through our thriving apartment community and amenities.",
  "property_seo_title_thankyou": "Thank You | Copper Stone",
  "property_seo_description_thankyou": "Thank you for reaching out to Copper Stone in Colorado Springs! A team member will connect with you soon to help you find your perfect home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Colorado Springs, CO",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791841621342",
  "amenities": [
    {
      "id": "ec_84ac6eb357318101d1c703ff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "yardi",
      "external_id": "86111844",
      "title": "24 Hour Availability",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ddd2d01f24860a7110f68242",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "yardi",
      "external_id": "86111846",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_620fef90de80ca5793656d22",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "yardi",
      "external_id": "86111851",
      "title": "Laundry Facilities/Laundry Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_03f99cc1d1726fb3b37107bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "yardi",
      "external_id": "86111855",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e64b7732b9e25c045f2de71c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "yardi",
      "external_id": "86111848",
      "title": "Courtesy Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4c32d38d33befa15e65f0d7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "yardi",
      "external_id": "86111850",
      "title": "Planned Social Activities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2907cc79631c5f0f715015bc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "yardi",
      "external_id": "124799835",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1eb130ae28b088998b0f0373",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "yardi",
      "external_id": "121234649",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-caa2-7449-971e-d5037f0c3b6d.webp",
      "amenity_image_media": {
        "alt_text": "Covered parking spaces with multiple vehicles parked.",
        "public_id": "019d021f-caa2-7449-971e-d5037f0c3b6d",
        "storage_key": "property/6767906449167194/019d021f-caa2-7449-971e-d5037f0c3b6d.webp",
        "width": 2560,
        "height": 1707
      },
      "amenity_image_alt_text": "Copper Stone Parking Apartments in Colorado Springs, CO",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9a6d67e963e0536f593ef5c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "yardi",
      "external_id": "86111854",
      "title": "Pet Play Area/ Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7808a8573a0c5a2bc308259",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "yardi",
      "external_id": "86111856",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0a5123f4a2c989ec2c6021ab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "yardi",
      "external_id": "86111857",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c7fd9677cab31e552ee602ce",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "yardi",
      "external_id": "86111859",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d49d6ad00e094f4ced205d4a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "yardi",
      "external_id": "86111860",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/01a171a2-3e32-711e-a780-7dd0bba84fa9.webp",
      "amenity_image_media": {
        "alt_text": "Balcony view with seating area and trees outside.",
        "public_id": "01a171a2-3e32-711e-a780-7dd0bba84fa9",
        "storage_key": "property/6767906449167194/01a171a2-3e32-711e-a780-7dd0bba84fa9.webp",
        "width": 1023,
        "height": 683
      },
      "amenity_image_alt_text": "Copper Stone Balcony View",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8b8ea8d1b97dbb4e89e4ee72",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "yardi",
      "external_id": "86111862",
      "title": "Views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4b3098a1a132c5d7835736d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "yardi",
      "external_id": "86111865",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_822813dfbed6034e157f8dc1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "yardi",
      "external_id": "86111858",
      "title": "Energy Star Certified Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3df5257209dde8120f364eb4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "yardi",
      "external_id": "86111864",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_ebb317cd6ad2e2775b33ac9f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/01a16cb2-47c5-767c-b606-f9c1e424da9a.webp",
      "image_media": {
        "alt_text": "Living room with a couch, coffee table, and balcony access.",
        "public_id": "01a16cb2-47c5-767c-b606-f9c1e424da9a",
        "storage_key": "property/6767906449167194/01a16cb2-47c5-767c-b606-f9c1e424da9a.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a plush sofa with decorative pillows, a stylish coffee table, and a sliding glass door leading to a private balcony.",
      "link": "false",
      "alt_text": "Living room with a couch, coffee table, and balcony access.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites HR (1).jpg"
    },
    {
      "id": "ec_fd1291c969355eee1f47ecb9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/01a16cb2-5a50-73af-b547-e527dbe696a6.webp",
      "image_media": {
        "alt_text": "Living and dining room area with a sofa, coffee table, and dining set.",
        "public_id": "01a16cb2-5a50-73af-b547-e527dbe696a6",
        "storage_key": "property/6767906449167194/01a16cb2-5a50-73af-b547-e527dbe696a6.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with comfortable seating and a elegant dining set.",
      "link": "false",
      "alt_text": "Living and dining room area with a sofa, coffee table, and dining set.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites HR (2).jpg"
    },
    {
      "id": "ec_b300be9871478716520f5b13",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/01a16cb2-6aaa-77cd-b216-be6c135eea3e.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, desk, and chair.",
        "public_id": "01a16cb2-6aaa-77cd-b216-be6c135eea3e",
        "storage_key": "property/6767906449167194/01a16cb2-6aaa-77cd-b216-be6c135eea3e.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a comfortable sofa, elegant coffee table, and a dedicated workspace with a desk and chair. Perfect for relaxation and productivity.",
      "link": "false",
      "alt_text": "Living room with a sofa, coffee table, desk, and chair.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites HR (3).jpg"
    },
    {
      "id": "ec_b03ec84fa3e25e825e4e6201",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/01a16cb2-5a45-745c-bcd3-5a60c46ef0b3.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and a desk.",
        "public_id": "01a16cb2-5a45-745c-bcd3-5a60c46ef0b3",
        "storage_key": "property/6767906449167194/01a16cb2-5a45-745c-bcd3-5a60c46ef0b3.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sofa, armchair, and a functional desk space. The open layout connects seamlessly to the dining area and kitchen, offering a cohesive and inviting atmosphere.",
      "link": "false",
      "alt_text": "Living room with a sofa, armchair, coffee table, and a desk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites HR (4).jpg"
    },
    {
      "id": "ec_9f74aed0f45ba6c196483acd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/01a16cb2-59f6-712b-975d-344d0b77ddf0.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with dining table set for four.",
        "public_id": "01a16cb2-59f6-712b-975d-344d0b77ddf0",
        "storage_key": "property/6767906449167194/01a16cb2-59f6-712b-975d-344d0b77ddf0.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Apartment",
      "description": "Stylish dining area with a glass-top table and four chairs, adjacent to a well-equipped kitchen featuring wooden cabinets and black appliances. Perfect for intimate meals.",
      "link": "false",
      "alt_text": "Dining area and kitchen with dining table set for four.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites HR (5).jpg"
    },
    {
      "id": "ec_e6bff4ad7093b8c65080249a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/01a16cb2-5a41-7048-9eee-b97c92be7230.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, two nightstands with lamps, and a closet.",
        "public_id": "01a16cb2-5a41-7048-9eee-b97c92be7230",
        "storage_key": "property/6767906449167194/01a16cb2-5a41-7048-9eee-b97c92be7230.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Apartment",
      "description": "Relax in this cozy bedroom, featuring a comfortable queen-size bed, elegant nightstands with lamps, and a spacious closet for all your storage needs.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, two nightstands with lamps, and a closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites HR (8).jpg"
    },
    {
      "id": "ec_cc28b9f5fa2ce077e128a9b6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/01a16cb2-7e97-73c2-9924-89e694acc4ca.webp",
      "image_media": {
        "alt_text": "Bedroom with closet space",
        "public_id": "01a16cb2-7e97-73c2-9924-89e694acc4ca",
        "storage_key": "property/6767906449167194/01a16cb2-7e97-73c2-9924-89e694acc4ca.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Apartment",
      "description": "This bedroom offers ample closet space for storage.",
      "link": "false",
      "alt_text": "Bedroom with closet space",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites HR (9).jpg"
    },
    {
      "id": "ec_0250a2dbdfde8a8ca9bdb568",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/01a16cb2-7ea8-776b-99b6-98887d59dee3.webp",
      "image_media": {
        "alt_text": "Bedroom with large closet and dresser with mirror",
        "public_id": "01a16cb2-7ea8-776b-99b6-98887d59dee3",
        "storage_key": "property/6767906449167194/01a16cb2-7ea8-776b-99b6-98887d59dee3.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large closet, a comfortable bed with plush bedding, and elegant dark wood dresser with a mirror.",
      "link": "false",
      "alt_text": "Bedroom with large closet and dresser with mirror",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites HR (10).jpg"
    },
    {
      "id": "ec_3a3a538d643ecc1a2012a900",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/01a16cb2-803c-76ba-8f39-6baddc2322a8.webp",
      "image_media": {
        "alt_text": "Bedroom with closet doors and a window.",
        "public_id": "01a16cb2-803c-76ba-8f39-6baddc2322a8",
        "storage_key": "property/6767906449167194/01a16cb2-803c-76ba-8f39-6baddc2322a8.webp",
        "width": 2560,
        "height": 1440
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, a large closet with sliding doors, and a bright window.",
      "link": "false",
      "alt_text": "Bedroom with closet doors and a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites HR (13).jpg"
    },
    {
      "id": "ec_ef9cbc5597f906681c910f16",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-67f4-7428-8794-281db58a84f3.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, wooden cabinets, refrigerator, microwave, and stove.",
        "public_id": "019d021f-67f4-7428-8794-281db58a84f3",
        "storage_key": "property/6767906449167194/019d021f-67f4-7428-8794-281db58a84f3.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Charming kitchen featuring granite countertops, ample wooden cabinetry, a refrigerator, microwave, and a stove for all your culinary needs.",
      "link": "false",
      "alt_text": "Kitchen with granite countertops, wooden cabinets, refrigerator, microwave, and stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites (6).jpg"
    },
    {
      "id": "ec_ee3cdb9dc879329a9cfb9468",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/01a16cb2-815e-7598-b505-5c5d9101b5ce.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, wood cabinets, black appliances, and stainless steel sink.",
        "public_id": "01a16cb2-815e-7598-b505-5c5d9101b5ce",
        "storage_key": "property/6767906449167194/01a16cb2-815e-7598-b505-5c5d9101b5ce.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring granite countertops, ample wood cabinetry, and a full suite of black appliances, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Kitchen with granite countertops, wood cabinets, black appliances, and stainless steel sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites HR (7).jpg"
    },
    {
      "id": "ec_fde7563bb3edca80681baa0e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/01a16cb2-8d20-77e4-a364-91e9adfe0637.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink and mirror, and a toilet next to a bathtub with a shower curtain.",
        "public_id": "01a16cb2-8d20-77e4-a364-91e9adfe0637",
        "storage_key": "property/6767906449167194/01a16cb2-8d20-77e4-a364-91e9adfe0637.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a spacious vanity with a granite countertop, a large mirror with decorative lights above, and a separate area with a toilet and bathtub.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink and mirror, and a toilet next to a bathtub with a shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites HR (11).jpg"
    },
    {
      "id": "ec_29c79115caedaeaf150f2713",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/01a16cb2-98f8-73db-84ce-66aa509bfe7d.webp",
      "image_media": {
        "alt_text": "Balcony with two chairs and a plant, overlooking trees and buildings.",
        "public_id": "01a16cb2-98f8-73db-84ce-66aa509bfe7d",
        "storage_key": "property/6767906449167194/01a16cb2-98f8-73db-84ce-66aa509bfe7d.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee on this charming balcony, complete with seating and lush greenery.",
      "link": "false",
      "alt_text": "Balcony with two chairs and a plant, overlooking trees and buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites HR (12).jpg"
    },
    {
      "id": "ec_ed828f9d9488b224201cd798",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-8d83-778d-ad9c-d4d3dcdb3ab1.webp",
      "image_media": {
        "alt_text": "View of the outdoor pool from the indoor lounge area with tables and seating.",
        "public_id": "019d021f-8d83-778d-ad9c-d4d3dcdb3ab1",
        "storage_key": "property/6767906449167194/019d021f-8d83-778d-ad9c-d4d3dcdb3ab1.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, perfect for relaxing and unwinding. Adjacent indoor lounge area provides comfortable seating and dining options.",
      "link": "false",
      "alt_text": "View of the outdoor pool from the indoor lounge area with tables and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites (16).jpg"
    },
    {
      "id": "ec_1935172583610bfa06ba6681",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/01a16cb2-9cac-72cc-b59f-a3b246f0c406.webp",
      "image_media": {
        "alt_text": "Comfortable lounge area with curved sectional sofa, coffee table, and bar seating area.",
        "public_id": "01a16cb2-9cac-72cc-b59f-a3b246f0c406",
        "storage_key": "property/6767906449167194/01a16cb2-9cac-72cc-b59f-a3b246f0c406.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Community",
      "description": "Relax and socialize in our spacious community lounge, featuring ample seating, a convenient bar area, and elegant dining spaces perfect for gatherings.",
      "link": "false",
      "alt_text": "Comfortable lounge area with curved sectional sofa, coffee table, and bar seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites HR (17).jpg"
    },
    {
      "id": "ec_9d3f4ac56bca1e3c1a60ea81",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/01a16cb2-9fcb-728a-8f85-28ccb7e9c4a5.webp",
      "image_media": {
        "alt_text": "Office reception desk with coffee station and copier.",
        "public_id": "01a16cb2-9fcb-728a-8f85-28ccb7e9c4a5",
        "storage_key": "property/6767906449167194/01a16cb2-9fcb-728a-8f85-28ccb7e9c4a5.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Community",
      "description": "A welcoming office reception area featuring a modern desk, a convenient coffee station, and a copier, ready to assist residents.",
      "link": "false",
      "alt_text": "Office reception desk with coffee station and copier.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites HR (18).jpg"
    },
    {
      "id": "ec_62815b74f0e982b859f9d7aa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/01a16cb2-a364-7169-8f02-c1fd7f9ba1ba.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "01a16cb2-a364-7169-8f02-c1fd7f9ba1ba",
        "storage_key": "property/6767906449167194/01a16cb2-a364-7169-8f02-c1fd7f9ba1ba.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. The perfect place to soak up the sun and enjoy a refreshing dip.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites HR (14).jpg"
    },
    {
      "id": "ec_6683adad6250c7d3436e98b8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-8712-74af-8db5-2aed09c3377e.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with a black fence and mailboxes in the foreground.",
        "public_id": "019d021f-8712-74af-8db5-2aed09c3377e",
        "storage_key": "property/6767906449167194/019d021f-8712-74af-8db5-2aed09c3377e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush landscaping and convenient mailboxes.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with a black fence and mailboxes in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites (15).jpg"
    },
    {
      "id": "ec_91fd07be140651dfcd6ee507",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/01a16cb2-ab88-7344-9fe3-ceb89f5755f7.webp",
      "image_media": {
        "alt_text": "Copper Stone Apartment Homes monument sign and building exterior",
        "public_id": "01a16cb2-ab88-7344-9fe3-ceb89f5755f7",
        "storage_key": "property/6767906449167194/01a16cb2-ab88-7344-9fe3-ceb89f5755f7.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Community",
      "description": "Exterior view of the Copper Stone Apartment Homes building with its monument sign. Offers a welcoming approach to the community.",
      "link": "false",
      "alt_text": "Copper Stone Apartment Homes monument sign and building exterior",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites HR (23).jpg"
    },
    {
      "id": "ec_0154d4b704d33424f7a24544",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-a8c8-75de-aa60-026ed17e3ab2.webp",
      "image_media": {
        "alt_text": "Copper Stone Apartment Homes monument sign with address 2827.",
        "public_id": "019d021f-a8c8-75de-aa60-026ed17e3ab2",
        "storage_key": "property/6767906449167194/019d021f-a8c8-75de-aa60-026ed17e3ab2.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Welcome to Copper Stone Apartment Homes. Monument sign with office directions and address 2827.",
      "link": "false",
      "alt_text": "Copper Stone Apartment Homes monument sign with address 2827.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites (24).jpg"
    },
    {
      "id": "ec_9635ceb2a47ed43ad0d7234c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-ad94-754d-8e8b-6ba404bc451c.webp",
      "image_media": {
        "alt_text": "Copper Stone Apartment Homes monument sign with building exterior and landscaping in the background.",
        "public_id": "019d021f-ad94-754d-8e8b-6ba404bc451c",
        "storage_key": "property/6767906449167194/019d021f-ad94-754d-8e8b-6ba404bc451c.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Welcome to Copper Stone Apartment Homes, featuring a stone exterior and beautiful landscaping. Find our leasing office with the directional arrow.",
      "link": "false",
      "alt_text": "Copper Stone Apartment Homes monument sign with building exterior and landscaping in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites (25).jpg"
    },
    {
      "id": "ec_4c53f86914ab2c84c1c7a7de",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/01a16cb2-b8d8-72da-bbab-27c91737f8af.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with balconies and landscaping.",
        "public_id": "01a16cb2-b8d8-72da-bbab-27c91737f8af",
        "storage_key": "property/6767906449167194/01a16cb2-b8d8-72da-bbab-27c91737f8af.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Community",
      "description": "Discover comfortable living in this apartment community, featuring well-maintained exteriors and beautiful landscaping.",
      "link": "false",
      "alt_text": "Exterior of apartment building with balconies and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites HR (19).jpg"
    },
    {
      "id": "ec_7156d1d5375a7ec0fa2cdb3b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-9b30-708d-8c8c-12d0bfa954ef.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with stone accents, balconies, and lush landscaping.",
        "public_id": "019d021f-9b30-708d-8c8c-12d0bfa954ef",
        "storage_key": "property/6767906449167194/019d021f-9b30-708d-8c8c-12d0bfa954ef.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Discover charming apartment living surrounded by beautiful landscaping and stone architecture.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with stone accents, balconies, and lush landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites (20).jpg"
    },
    {
      "id": "ec_b95021d0c314891990ab8872",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/01a16cb2-bcb7-76c0-9a20-0545c8ab1317.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with stone facade and balconies surrounded by trees and landscaping.",
        "public_id": "01a16cb2-bcb7-76c0-9a20-0545c8ab1317",
        "storage_key": "property/6767906449167194/01a16cb2-bcb7-76c0-9a20-0545c8ab1317.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Community",
      "description": "Charming exterior of apartment buildings featuring a stone facade, wooden balconies, and lush greenery, creating a welcoming community atmosphere.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with stone facade and balconies surrounded by trees and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites HR (21).jpg"
    },
    {
      "id": "ec_7610bb6c329ae43221dc2239",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/01a16cb2-c2f8-740a-b240-45f058520dbf.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with stone accents and wooden balconies.",
        "public_id": "01a16cb2-c2f8-740a-b240-45f058520dbf",
        "storage_key": "property/6767906449167194/01a16cb2-c2f8-740a-b240-45f058520dbf.webp",
        "width": 2560,
        "height": 1709
      },
      "title": "Community",
      "description": "Discover charming apartment living with unique stone accents and warm wooden balconies, surrounded by lush landscaping.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with stone accents and wooden balconies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Copper-Stone_Favorites HR (22).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_f86f2461-e4a1-4f0e-829c-9e9e25006e08",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Babes Espresso",
      "poi_type": "Restaurants",
      "poi_address": "1234 E Pikes Peak Ave, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-d77f-779d-a00b-eb7029526418.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-d77f-779d-a00b-eb7029526418",
        "storage_key": "property/6767906449167194/019d021f-d77f-779d-a00b-eb7029526418.webp",
        "width": 1133,
        "height": 671
      },
      "poi_business_url": "http://www.babesespresso.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16764012892399340753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "babes-espresso",
      "poi_latitude": "38.8335168",
      "poi_longitude": "-104.8024887",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 719-212-9331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3d25-75ca-931b-c41543203ab2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3d25-75ca-931b-c41543203ab2",
        "storage_key": "property/6767906449167194/019d0220-3d25-75ca-931b-c41543203ab2.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJn4igfrJFE4cR0QyI9ee8peg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_7a91709c-2fd9-4412-bbfa-19f038e0cb5c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Nemo's Coffee Shop",
      "poi_type": "Restaurants",
      "poi_address": "2114 E Pikes Peak Ave, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Chill hangout with espresso, smoothies, house-baked pastries, breakfast/lunch fare & a drive-thru.",
      "poi_long_description": "Chill hangout with espresso, smoothies, house-baked pastries, breakfast/lunch fare & a drive-thru.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-d80e-73bb-abf2-b67c7b83d019.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-d80e-73bb-abf2-b67c7b83d019",
        "storage_key": "property/6767906449167194/019d021f-d80e-73bb-abf2-b67c7b83d019.webp",
        "width": 803,
        "height": 600
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7882962040602643653&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nemos-coffee-shop",
      "poi_latitude": "38.8330041",
      "poi_longitude": "-104.7899615",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 719-635-2745",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3d25-75ca-931b-c41543203ab2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3d25-75ca-931b-c41543203ab2",
        "storage_key": "property/6767906449167194/019d0220-3d25-75ca-931b-c41543203ab2.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJST8Gma1FE4cRxUwC0DXoZW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_3ba779d4-53d2-4d5c-b613-d68868a39791",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "UCHealth - Memorial Administrative Center",
      "poi_type": "Restaurants",
      "poi_address": "2420 E Pikes Peak Ave, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Administrative center, with friendly and informative staff, administering COVID vaccines.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-d7af-7782-9d92-7e79011ecaec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-d7af-7782-9d92-7e79011ecaec",
        "storage_key": "property/6767906449167194/019d021f-d7af-7782-9d92-7e79011ecaec.webp",
        "width": 987,
        "height": 1280
      },
      "poi_business_url": "https://www.uchealth.org/locations/uchealth-memorial-administrative-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=16993542043317576553&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uchealth---memorial-administrative-center",
      "poi_latitude": "38.8334732",
      "poi_longitude": "-104.7860085",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cc8-771f-a2e5-1f61654d83cb",
        "storage_key": "property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHccTFrJFE4cRaSOc53Mw1es",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_7934cd7c-7cc7-4e0a-acef-716180b117f8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "The Fiesta Grill (Food Truck)",
      "poi_type": "Restaurants",
      "poi_address": "4305 E Platte Ave, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Casual Mexican joint dishing up street tacos and other comfort grub, including popular carne asada fries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-d7af-7782-9d92-80da9a4223b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-d7af-7782-9d92-80da9a4223b0",
        "storage_key": "property/6767906449167194/019d021f-d7af-7782-9d92-80da9a4223b0.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18152917633580842231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-fiesta-grill-food-truck",
      "poi_latitude": "38.8389676",
      "poi_longitude": "-104.7472629",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 719-644-1499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3d2a-772a-a733-1efb821a95ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3d2a-772a-a733-1efb821a95ff",
        "storage_key": "property/6767906449167194/019d0220-3d2a-772a-a733-1efb821a95ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-ZWwbCtEE4cR97yC0mge7Ps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2a356a62-42a8-4001-9e79-08faa7209047",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Popeyes Louisiana Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "3815 E Pikes Peak Ave, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Louisiana-inspired fast-food chain known for its crispy fried chicken, chicken sandwiches & fries.",
      "poi_long_description": "Louisiana-inspired fast-food chain known for its crispy fried chicken, chicken sandwiches & fries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-dd1b-7515-a8f4-95fdfdeb9a30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-dd1b-7515-a8f4-95fdfdeb9a30",
        "storage_key": "property/6767906449167194/019d021f-dd1b-7515-a8f4-95fdfdeb9a30.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.popeyes.com/store-locator/store/restaurant_81891",
      "poi_directions_map_url": "https://maps.google.com/?cid=14112194948517804717&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "popeyes-louisiana-kitchen",
      "poi_latitude": "38.8313353",
      "poi_longitude": "-104.7567297",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-591-2114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3d2a-772a-a733-1efb821a95ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3d2a-772a-a733-1efb821a95ff",
        "storage_key": "property/6767906449167194/019d0220-3d2a-772a-a733-1efb821a95ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwz5obytEE4cRrTp3O4mW2MM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "custom_5393243a-9408-47e1-ab88-366fe4e45816",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Phantom Canyon Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "2 E Pikes Peak Ave, Colorado Springs, CO 80903, USA",
      "poi_short_description": "3-story brewery housed in a historic building features microbrews, a billiards hall & American fare.",
      "poi_long_description": "3-story brewery housed in a historic building features microbrews, a billiards hall & American fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-defa-70c1-9aa5-94e69c419426.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-defa-70c1-9aa5-94e69c419426",
        "storage_key": "property/6767906449167194/019d021f-defa-70c1-9aa5-94e69c419426.webp",
        "width": 1055,
        "height": 594
      },
      "poi_business_url": "https://phantomcanyon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14820482904266189490&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phantom-canyon-brewing-company",
      "poi_latitude": "38.8342281",
      "poi_longitude": "-104.8249417",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 719-635-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cd0-74dc-8440-78e5b087333f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cd0-74dc-8440-78e5b087333f",
        "storage_key": "property/6767906449167194/019d0220-3cd0-74dc-8440-78e5b087333f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFc5c2SJFE4cRsiqJ3K3urM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "custom_2e529ab2-079c-4a29-93fb-6e042880f787",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "La Baguette Cafe and Espresso Bar",
      "poi_type": "Restaurants",
      "poi_address": "117 E Pikes Peak Ave, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Quaint bakery & cafe offering soup, sandwiches & coffee, plus fresh bread & French pastries.",
      "poi_long_description": "Quaint bakery & cafe offering soup, sandwiches & coffee, plus fresh bread & French pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-de2b-744e-be63-589aab6a8c92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-de2b-744e-be63-589aab6a8c92",
        "storage_key": "property/6767906449167194/019d021f-de2b-744e-be63-589aab6a8c92.webp",
        "width": 811,
        "height": 609
      },
      "poi_business_url": "https://labaguette-co.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5318439086758102026&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-baguette-cafe-and-espresso-bar",
      "poi_latitude": "38.8336295",
      "poi_longitude": "-104.8226312",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 719-636-5020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3d2a-772a-a733-1efb821a95ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3d2a-772a-a733-1efb821a95ff",
        "storage_key": "property/6767906449167194/019d0220-3d2a-772a-a733-1efb821a95ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBbygmyJFE4cRCgTFzSvkzkk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "french_restaurant"
    },
    {
      "id": "custom_5c864e52-b365-4f5d-a2e1-f87dda84cb12",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Springs Orleans",
      "poi_type": "Restaurants",
      "poi_address": "123 E Pikes Peak Ave, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Classic Cajun-Creole cuisine in an elegant, airy space that hosts live jazz & special performances.",
      "poi_long_description": "Classic Cajun-Creole cuisine in an elegant, airy space that hosts live jazz & special performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-df25-77f8-88c9-7dbeecc56013.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-df25-77f8-88c9-7dbeecc56013",
        "storage_key": "property/6767906449167194/019d021f-df25-77f8-88c9-7dbeecc56013.webp",
        "width": 1280,
        "height": 840
      },
      "poi_business_url": "http://www.springsorleans.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13222390713798023290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "springs-orleans",
      "poi_latitude": "38.8336502",
      "poi_longitude": "-104.8223943",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 719-520-0123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3d2a-772a-a733-1efb821a95ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3d2a-772a-a733-1efb821a95ff",
        "storage_key": "property/6767906449167194/019d0220-3d2a-772a-a733-1efb821a95ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ26aMnCJFE4cRethaiUxef7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "custom_70b90e5c-62f5-48d4-951c-d7ebe04cc8d0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Jax Fish House & Oyster Bar",
      "poi_type": "Restaurants",
      "poi_address": "11 S Tejon St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Upscale chain serving gourmet seafood dishes & creative cocktails in a relaxed, stylish setting.",
      "poi_long_description": "Upscale chain serving gourmet seafood dishes & creative cocktails in a relaxed, stylish setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-e29c-7253-bd53-73678d602e5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-e29c-7253-bd53-73678d602e5c",
        "storage_key": "property/6767906449167194/019d021f-e29c-7253-bd53-73678d602e5c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jaxfishhouse.com/location/jax-fish-house-oyster-bar-colorado-springs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18041131725252240201&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jax-fish-house--oyster-bar",
      "poi_latitude": "38.8334586",
      "poi_longitude": "-104.8233604",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 719-357-4554",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3d2a-772a-a733-1efb821a95ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3d2a-772a-a733-1efb821a95ff",
        "storage_key": "property/6767906449167194/019d0220-3d2a-772a-a733-1efb821a95ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbU-b31dFE4cRSaOw1bf5Xvo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_7d5e5b6e-47b7-48e8-adae-f04f96b90414",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Jack Quinn's Irish Pub and Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "21 S Tejon St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Comfy Irish pub home to traditional cuisine, grog, sing-alongs & a local running club's home base.",
      "poi_long_description": "Comfy Irish pub home to traditional cuisine, grog, sing-alongs & a local running club's home base.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-e325-71ab-93a4-1331447ee78a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-e325-71ab-93a4-1331447ee78a",
        "storage_key": "property/6767906449167194/019d021f-e325-71ab-93a4-1331447ee78a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jackquinnspub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12925004250212670892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack-quinns-irish-pub-and-restaurant",
      "poi_latitude": "38.832991",
      "poi_longitude": "-104.823384",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 719-385-0766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3d2a-772a-a733-1efb821a95ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3d2a-772a-a733-1efb821a95ff",
        "storage_key": "property/6767906449167194/019d0220-3d2a-772a-a733-1efb821a95ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwZQQiiJFE4cRrB1XzuLWXrM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "irish_restaurant"
    },
    {
      "id": "custom_22433864-d130-4fef-b479-d8b7a22b108d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "The Rabbit Hole",
      "poi_type": "Restaurants",
      "poi_address": "101 N Tejon St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Late-night New American haunt crafting creative bites & cocktails in a sleek, subterranean space.",
      "poi_long_description": "Late-night New American haunt crafting creative bites & cocktails in a sleek, subterranean space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-e3d3-779e-b696-222c919511b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-e3d3-779e-b696-222c919511b4",
        "storage_key": "property/6767906449167194/019d021f-e3d3-779e-b696-222c919511b4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://rabbitholedinner.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12258295772924282042&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-rabbit-hole",
      "poi_latitude": "38.8354621",
      "poi_longitude": "-104.8229839",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 719-203-5072",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3d2a-772a-a733-1efb821a95ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3d2a-772a-a733-1efb821a95ff",
        "storage_key": "property/6767906449167194/019d0220-3d2a-772a-a733-1efb821a95ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEyBeTT1FE4cRugTT6A43Hqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_cb9c56e1-3a8f-41c5-b01e-991227d72ad6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "East Coast Deli",
      "poi_type": "Restaurants",
      "poi_address": "24 S Tejon St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Compact, quaint eatery adorned with photos of NYC serving deli sandwiches, burgers & omelets.",
      "poi_long_description": "Compact, quaint eatery adorned with photos of NYC serving deli sandwiches, burgers & omelets.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-e3d0-7609-81d9-a20d7733302c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-e3d0-7609-81d9-a20d7733302c",
        "storage_key": "property/6767906449167194/019d021f-e3d0-7609-81d9-a20d7733302c.webp",
        "width": 1060,
        "height": 596
      },
      "poi_business_url": "https://www.eastcoastdelico.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3563321576251392928&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-coast-deli",
      "poi_latitude": "38.8329154",
      "poi_longitude": "-104.8237808",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 719-633-4522",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-40b0-7049-b7b1-fc0e6c973522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-40b0-7049-b7b1-fc0e6c973522",
        "storage_key": "property/6767906449167194/019d0220-40b0-7049-b7b1-fc0e6c973522.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJr72K9CJFE4cRoAPzJBh2czE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "deli"
    },
    {
      "id": "custom_cbf3f6cf-fcff-459c-88d3-e925345eebf3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Commonfork Bites & Brews",
      "poi_type": "Restaurants",
      "poi_address": "21 N Nevada Ave, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Bar & restaurant at CityROCK climbing gym offering creative, health-oriented eats & craft brews.",
      "poi_long_description": "Bar & restaurant at CityROCK climbing gym offering creative, health-oriented eats & craft brews.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-e7cc-747b-a7a3-a65ed1aeddac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-e7cc-747b-a7a3-a65ed1aeddac",
        "storage_key": "property/6767906449167194/019d021f-e7cc-747b-a7a3-a65ed1aeddac.webp",
        "width": 640,
        "height": 960
      },
      "poi_business_url": "https://commonfork.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9525095659206113413&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "commonfork-bites--brews",
      "poi_latitude": "38.834864",
      "poi_longitude": "-104.8213754",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 719-634-0003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3d2a-772a-a733-1efb821a95ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3d2a-772a-a733-1efb821a95ff",
        "storage_key": "property/6767906449167194/019d0220-3d2a-772a-a733-1efb821a95ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9XYzERhFE4cRhXiYMgnwL4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b77a853d-5646-4530-a17e-1de4593297c8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Josh & John's",
      "poi_type": "Restaurants",
      "poi_address": "329 N Tejon St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Counter-serve place dishing up ice cream, waffle cones, shakes, malts and floats.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-e9e9-73eb-8dd6-f99d5d6df051.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-e9e9-73eb-8dd6-f99d5d6df051",
        "storage_key": "property/6767906449167194/019d021f-e9e9-73eb-8dd6-f99d5d6df051.webp",
        "width": 1280,
        "height": 828
      },
      "poi_business_url": "https://www.joshandjohns.com/downtown-colorado-springs",
      "poi_directions_map_url": "https://maps.google.com/?cid=9298234349052869864&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "josh--johns",
      "poi_latitude": "38.8392676",
      "poi_longitude": "-104.823055",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 719-632-0299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3d2a-772a-a733-1efb821a95ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3d2a-772a-a733-1efb821a95ff",
        "storage_key": "property/6767906449167194/019d0220-3d2a-772a-a733-1efb821a95ff.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZXsVkCJFE4cR6LyhVeD2CYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "custom_2fd6a10e-4d03-4296-84c1-e60ee3692cf0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Loaf N Jug",
      "poi_type": "Shopping & Retail",
      "poi_address": "2802 E Pikes Peak Ave, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Convenience-store chain with snacks, coffee & basic groceries (many with gas, ATMs & movie rentals).",
      "poi_long_description": "Convenience-store chain with snacks, coffee & basic groceries (many with gas, ATMs & movie rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-e87e-767e-bd9b-6e5243e1c184.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-e87e-767e-bd9b-6e5243e1c184",
        "storage_key": "property/6767906449167194/019d021f-e87e-767e-bd9b-6e5243e1c184.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.loafnjug.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4775439882694112319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "loaf-n-jug",
      "poi_latitude": "38.8329674",
      "poi_longitude": "-104.7754515",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 719-633-8623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-40b5-760f-8157-d4644b75b0d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-40b5-760f-8157-d4644b75b0d8",
        "storage_key": "property/6767906449167194/019d0220-40b5-760f-8157-d4644b75b0d8.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJy6t-ncpFE4cRPzQ3nkXFRUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_b7370aee-012f-4ac3-ab92-631b6c30abf0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "1425 S Murray Blvd, Colorado Springs, CO 80916, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-e92f-73c6-853c-8b9546b7db37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-e92f-73c6-853c-8b9546b7db37",
        "storage_key": "property/6767906449167194/019d021f-e92f-73c6-853c-8b9546b7db37.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://local.safeway.com/safeway/co/colorado-springs/1425-s-murray-blvd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=13006837337226455203&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "38.81251049999999",
      "poi_longitude": "-104.7463599",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 719-591-0880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-40b8-73f0-9f2b-c143d5d696b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-40b8-73f0-9f2b-c143d5d696b6",
        "storage_key": "property/6767906449167194/019d0220-40b8-73f0-9f2b-c143d5d696b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4XPRjqFGE4cRo6irIKWRgbQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_73ca530d-a830-4d94-abf3-cf6db50248bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "King Soopers",
      "poi_type": "Shopping & Retail",
      "poi_address": "2910 S Academy Blvd, Colorado Springs, CO 80916, USA",
      "poi_short_description": "Store, part of a grocery chain, stocking staples and household items, plus a bakery, fresh produce and meat departments.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-ed0c-7327-9f55-c4bb0963f143.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-ed0c-7327-9f55-c4bb0963f143",
        "storage_key": "property/6767906449167194/019d021f-ed0c-7327-9f55-c4bb0963f143.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.kingsoopers.com/stores/grocery/co/colorado-springs/hancock-plaza/620/00103?cid=loc_62000103_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=1970131545270570025&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "king-soopers",
      "poi_latitude": "38.7904238",
      "poi_longitude": "-104.7606495",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 719-393-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-40b8-73f0-9f2b-c143d5d696b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-40b8-73f0-9f2b-c143d5d696b6",
        "storage_key": "property/6767906449167194/019d0220-40b8-73f0-9f2b-c143d5d696b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE9eOVf9DE4cRKcykxDNQVxs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_9d65d0c1-f5d4-4716-bea1-511a73f115d9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "455 N Circle Dr, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-ee56-73ad-8a70-dd49fd9e0d9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-ee56-73ad-8a70-dd49fd9e0d9a",
        "storage_key": "property/6767906449167194/019d021f-ee56-73ad-8a70-dd49fd9e0d9a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/colorado-springs-co-pharmacies/455-north-circle-dr-colorado-springs-co-80909/storeid=11002?WT.mc_id=LS_GOOGLE_FS_11002",
      "poi_directions_map_url": "https://maps.google.com/?cid=9124733950549795883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "38.8392159",
      "poi_longitude": "-104.775075",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 719-216-0408",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cc8-771f-a2e5-1f61654d83cb",
        "storage_key": "property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxf6pDv1FE4cRK6R34C6RoX4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_363cc1b5-bb90-468d-ab9d-6468e60e423f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "920 N Circle Dr, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-ee56-73ad-8a70-daf2c4ee65c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-ee56-73ad-8a70-daf2c4ee65c3",
        "storage_key": "property/6767906449167194/019d021f-ee56-73ad-8a70-daf2c4ee65c3.webp",
        "width": 1280,
        "height": 1156
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-920+n+circle+dr-colorado+springs-co-80909/id=4043",
      "poi_directions_map_url": "https://maps.google.com/?cid=6208988613047407678&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "38.8465111",
      "poi_longitude": "-104.7765644",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-473-9090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cc8-771f-a2e5-1f61654d83cb",
        "storage_key": "property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHwtmS79FE4cRPtQiNz_CKlY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_18274a1d-621b-4b79-8152-e8fdaf4260e1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "3805 E Pikes Peak Ave, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-efd7-74c2-86e0-afd410015f6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-efd7-74c2-86e0-afd410015f6e",
        "storage_key": "property/6767906449167194/019d021f-efd7-74c2-86e0-afd410015f6e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.7-eleven.com/locations/co/colorado-springs/3805-e.-pikes-peak-ave-23935?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3791864852441769036&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "38.8315595",
      "poi_longitude": "-104.7567569",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 719-597-9986",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-40b5-760f-8157-d4644b75b0d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-40b5-760f-8157-d4644b75b0d8",
        "storage_key": "property/6767906449167194/019d0220-40b5-760f-8157-d4644b75b0d8.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJAYLsZStEE4cRTKQUPv5onzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_a6bb7f78-b8c2-4ba5-804d-4b45a31dde82",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "3201 E Platte Ave, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Retail chain stocking clothing, electronics and home goods, plus furniture, toys, sporting goods and groceries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-f2e2-75ea-8215-11443bb9929d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-f2e2-75ea-8215-11443bb9929d",
        "storage_key": "property/6767906449167194/019d021f-f2e2-75ea-8215-11443bb9929d.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1200-colorado-springs-co/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=12309067056574801145&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "38.8374952",
      "poi_longitude": "-104.7705078",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 719-578-9164",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-40b0-7049-b7b1-fc0e6c973522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-40b0-7049-b7b1-fc0e6c973522",
        "storage_key": "property/6767906449167194/019d0220-40b0-7049-b7b1-fc0e6c973522.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOTPuqM5FE4cR-aSaj0WX0qo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_7e72a624-ff8f-43e3-893e-a277629a4b1a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "701 N Academy Blvd, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-f319-77cd-a61d-9a8939c72ffc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-f319-77cd-a61d-9a8939c72ffc",
        "storage_key": "property/6767906449167194/019d021f-f319-77cd-a61d-9a8939c72ffc.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/CO-Colorado-Springs/2806?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-2806-_-na-_-0-_-0&y_source=1_MTE4Mzg5OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=15869924443495454699&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "38.84338109999999",
      "poi_longitude": "-104.756082",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 719-313-4650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-40b0-7049-b7b1-fc0e6c973522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-40b0-7049-b7b1-fc0e6c973522",
        "storage_key": "property/6767906449167194/019d0220-40b0-7049-b7b1-fc0e6c973522.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJE-Lb7dZFE4cR69fV6jJMPdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_6c9e19ba-dc8f-4df9-a937-6e6050383b46",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "The Citadel Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "750 Citadel Dr E, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Mall with apparel, cosmetics, jewelry & electronics stores, salons, a food court & play areas.",
      "poi_long_description": "Mall with apparel, cosmetics, jewelry & electronics stores, salons, a food court & play areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-f3a8-754c-80a4-5bda1b3125ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-f3a8-754c-80a4-5bda1b3125ad",
        "storage_key": "property/6767906449167194/019d021f-f3a8-754c-80a4-5bda1b3125ad.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://shopthecitadel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11809864765923250893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-citadel-mall",
      "poi_latitude": "38.8435391",
      "poi_longitude": "-104.7604257",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 719-591-5515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-40b0-7049-b7b1-fc0e6c973522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-40b0-7049-b7b1-fc0e6c973522",
        "storage_key": "property/6767906449167194/019d0220-40b0-7049-b7b1-fc0e6c973522.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJV8YVEdpFE4cRzdJB6m4R5aM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_3aec97e3-2efc-4d15-a892-de7de9e75531",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "PetSmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "571 N Academy Blvd, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_long_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-f4b3-73b8-bea1-725d229e3001.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-f4b3-73b8-bea1-725d229e3001",
        "storage_key": "property/6767906449167194/019d021f-f4b3-73b8-bea1-725d229e3001.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.petsmart.com/stores/us/co/colorado-springs-store0232.html?utm_source=google&utm_medium=organic&utm_campaign=google-my-business",
      "poi_directions_map_url": "https://maps.google.com/?cid=14249375373396406659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "petsmart",
      "poi_latitude": "38.8421023",
      "poi_longitude": "-104.7552915",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-570-1313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-40b0-7049-b7b1-fc0e6c973522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-40b0-7049-b7b1-fc0e6c973522",
        "storage_key": "property/6767906449167194/019d0220-40b0-7049-b7b1-fc0e6c973522.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJM5GPL9dFE4cRg_F92mfzv8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_07a16be1-57ab-4aa7-98fc-d1956c7ad886",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "IntelliTec College",
      "poi_type": "Education",
      "poi_address": "2315 E Pikes Peak Ave, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-f735-7428-87d9-6427ae36f423.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-f735-7428-87d9-6427ae36f423",
        "storage_key": "property/6767906449167194/019d021f-f735-7428-87d9-6427ae36f423.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://intellitec.edu/locations/colorado-springs-campus//?utm_source=Google%20My%20Business&utm_medium=Colorado%20Springs",
      "poi_directions_map_url": "https://maps.google.com/?cid=8624471222100021904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "intellitec-college",
      "poi_latitude": "38.8322298",
      "poi_longitude": "-104.7870641",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 719-632-7626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-4137-76be-ad57-03b9e9e0cfb4",
        "storage_key": "property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc1Ijf7JFE4cRkNLZ0OFGsHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_a2aa8d46-ab28-43aa-a829-08e6823e3fa5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Jack Swigert Aerospace Academy - Colorado Springs School District 11",
      "poi_type": "Education",
      "poi_address": "4220 E Pikes Peak Ave, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-f750-751d-bde3-a90564ca7204.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-f750-751d-bde3-a90564ca7204",
        "storage_key": "property/6767906449167194/019d021f-f750-751d-bde3-a90564ca7204.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://swigert.d11.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13491454383182433647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack-swigert-aerospace-academy---colorado-springs-school-district-11",
      "poi_latitude": "38.8358614",
      "poi_longitude": "-104.7502398",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-328-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-4137-76be-ad57-03b9e9e0cfb4",
        "storage_key": "property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSXlfkH9GE4cRb8353EdGO7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_aeee1441-1391-4fe8-8188-01c1266e829f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Madison Elementary School",
      "poi_type": "Education",
      "poi_address": "4120 Constitution Ave, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-f9e0-71ec-9612-d128b831bca3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-f9e0-71ec-9612-d128b831bca3",
        "storage_key": "property/6767906449167194/019d021f-f9e0-71ec-9612-d128b831bca3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://madison.d11.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14987509440751958560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "madison-elementary-school",
      "poi_latitude": "38.8623742",
      "poi_longitude": "-104.74941",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 719-328-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-4137-76be-ad57-03b9e9e0cfb4",
        "storage_key": "property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8c5tBwlGE4cRIHrV221U_s8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_cd1df580-3932-4d91-b3c2-4711b3365c2b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Edison Elementary School",
      "poi_type": "Education",
      "poi_address": "3125 N Hancock Ave, Colorado Springs, CO 80907, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://edison.d11.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=615287129552633120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edison-elementary-school",
      "poi_latitude": "38.8775077",
      "poi_longitude": "-104.802808",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 719-328-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-4137-76be-ad57-03b9e9e0cfb4",
        "storage_key": "property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXQx-JINPE4cRIL3aZ2LwiQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_4cc887fd-9ca6-4ff8-a0e0-419417b7d15b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Colorado Springs Charter Academy",
      "poi_type": "Education",
      "poi_address": "2577 N Chelton Rd, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-fcf8-76dc-8b57-6b113b21fa61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-fcf8-76dc-8b57-6b113b21fa61",
        "storage_key": "property/6767906449167194/019d021f-fcf8-76dc-8b57-6b113b21fa61.webp",
        "width": 1280,
        "height": 931
      },
      "poi_business_url": "http://cscharter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9220291869571490644&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colorado-springs-charter-academy",
      "poi_latitude": "38.8694739",
      "poi_longitude": "-104.771994",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 719-636-2722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-4137-76be-ad57-03b9e9e0cfb4",
        "storage_key": "property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLwyB9_RFE4cRVCM7q5oO9X8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_f743468f-3edd-4415-afe4-8ee968da45ac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Pikes Peak State College - Downtown Campus",
      "poi_type": "Education",
      "poi_address": "100 W Pikes Peak Ave, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-ffb5-7139-9da6-23d3ff6b01ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-ffb5-7139-9da6-23d3ff6b01ae",
        "storage_key": "property/6767906449167194/019d021f-ffb5-7139-9da6-23d3ff6b01ae.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.pikespeak.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7340678470133529635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pikes-peak-state-college---downtown-campus",
      "poi_latitude": "38.8350405",
      "poi_longitude": "-104.8273128",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 719-502-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-4137-76be-ad57-03b9e9e0cfb4",
        "storage_key": "property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ8R0sjxFE4cRI7yqDi1U32U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ab07c755-eee6-47ce-ba11-1b624f5c249d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "William J. Palmer High School",
      "poi_type": "Education",
      "poi_address": "301 N Nevada Ave, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d021f-ffcd-704b-96b1-b1c00b8a8b66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-ffcd-704b-96b1-b1c00b8a8b66",
        "storage_key": "property/6767906449167194/019d021f-ffcd-704b-96b1-b1c00b8a8b66.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://palmer.d11.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14196542344413939265&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-j-palmer-high-school",
      "poi_latitude": "38.83887929999999",
      "poi_longitude": "-104.8205955",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 719-328-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-4137-76be-ad57-03b9e9e0cfb4",
        "storage_key": "property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJteUASRZFE4cRQYaVtQtABMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_f13707c4-4c1c-491c-8b94-9a184b867c42",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Colorado College",
      "poi_type": "Education",
      "poi_address": "14 E Cache La Poudre St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-0147-72a8-858b-40b92b4216a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-0147-72a8-858b-40b92b4216a7",
        "storage_key": "property/6767906449167194/019d0220-0147-72a8-858b-40b92b4216a7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.coloradocollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=119468250609594234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colorado-college",
      "poi_latitude": "38.8491957",
      "poi_longitude": "-104.8254254",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 719-389-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-4137-76be-ad57-03b9e9e0cfb4",
        "storage_key": "property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR32_Z0BFE4cReq-Fr71vqAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_291743fc-8782-43fa-be31-209ddceaf7f9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "University of Colorado Colorado Springs",
      "poi_type": "Education",
      "poi_address": "1420 Austin Bluffs Pkwy, Colorado Springs, CO 80918, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-02c6-7398-833a-0127e3e3a628.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-02c6-7398-833a-0127e3e3a628",
        "storage_key": "property/6767906449167194/019d0220-02c6-7398-833a-0127e3e3a628.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.uccs.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10577512112395933892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-colorado-colorado-springs",
      "poi_latitude": "38.8928151",
      "poi_longitude": "-104.8007996",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 719-255-8227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-4137-76be-ad57-03b9e9e0cfb4",
        "storage_key": "property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnTn-iKBPE4cRxFjAYjnfypI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_59e060fb-94b5-4906-8786-bad13edf31d5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Early Connections Learning Centers",
      "poi_type": "Education",
      "poi_address": "104 E Rio Grande St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-05b5-7553-bf76-881bd95fe562.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-05b5-7553-bf76-881bd95fe562",
        "storage_key": "property/6767906449167194/019d0220-05b5-7553-bf76-881bd95fe562.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.earlyconnections.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12762394846958329623&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "early-connections-learning-centers",
      "poi_latitude": "38.8248007",
      "poi_longitude": "-104.8235475",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 719-632-1754",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-4137-76be-ad57-03b9e9e0cfb4",
        "storage_key": "property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW6bXjd9EE4cRFx86yH4iHbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_81c4d7fd-ba38-4d04-96a4-0297c996de93",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Stargazers Theatre & Event Center",
      "poi_type": "Entertainment",
      "poi_address": "10 S Parkside Dr, Colorado Springs, CO 80910, USA",
      "poi_short_description": "Performance space in an ex-cinema with a striking domed roof & 550 seats for concerts, plays & more.",
      "poi_long_description": "Performance space in an ex-cinema with a striking domed roof & 550 seats for concerts, plays & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-07b6-771d-a660-6743bb6984c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-07b6-771d-a660-6743bb6984c5",
        "storage_key": "property/6767906449167194/019d0220-07b6-771d-a660-6743bb6984c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.stargazerstheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14836543427657935638&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stargazers-theatre--event-center",
      "poi_latitude": "38.8318062",
      "poi_longitude": "-104.785347",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 719-476-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cc8-771f-a2e5-1f61654d83cb",
        "storage_key": "property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz5rr7rJFE4cRFis13KP95c0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_6d24fd1e-67b8-48d5-b4f5-d7255ed0356e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Pikes Peak Center For The Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "190 S Cascade Ave, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Premier venue for events ranging from musical concerts and comedy shows to dance and theater.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-0b50-710c-ae10-1dce7470c6de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-0b50-710c-ae10-1dce7470c6de",
        "storage_key": "property/6767906449167194/019d0220-0b50-710c-ae10-1dce7470c6de.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.pikespeakcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11500179945342731688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pikes-peak-center-for-the-performing-arts",
      "poi_latitude": "38.8309234",
      "poi_longitude": "-104.8265795",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 719-477-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cc8-771f-a2e5-1f61654d83cb",
        "storage_key": "property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJScDMxCNFE4cRqIU5z7rYmJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_28811486-18ac-492c-b7cb-68e8eb1493e5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "U.S. Olympic & Paralympic Museum",
      "poi_type": "Entertainment",
      "poi_address": "200 S Sierra Madre St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Displays on American athletes & Olympic history, plus immersive sport exhibits & simulators.",
      "poi_long_description": "Displays on American athletes & Olympic history, plus immersive sport exhibits & simulators.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-0b4f-7583-8946-7070084ba858.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-0b4f-7583-8946-7070084ba858",
        "storage_key": "property/6767906449167194/019d0220-0b4f-7583-8946-7070084ba858.webp",
        "width": 1280,
        "height": 1210
      },
      "poi_business_url": "https://usopm.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=652128693993578406&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "us-olympic--paralympic-museum",
      "poi_latitude": "38.8296712",
      "poi_longitude": "-104.8295217",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 719-497-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-449a-7768-9f46-cfa491b3bb9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-449a-7768-9f46-cfa491b3bb9a",
        "storage_key": "property/6767906449167194/019d0220-449a-7768-9f46-cfa491b3bb9a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJezHngJ5FE4cRpp9TkZfTDAk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f51f5d63-1b60-47fa-b5eb-815294f4e37d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Cheyenne Mountain Zoo",
      "poi_type": "Entertainment",
      "poi_address": "4250 Cheyenne Mountain Zoo Rd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Prominent conservation park with 700+ animals known for its big giraffe herd & feeding experiences.",
      "poi_long_description": "Prominent conservation park with 700+ animals known for its big giraffe herd & feeding experiences.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-0e7d-762a-9e93-fdfaa83653b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-0e7d-762a-9e93-fdfaa83653b9",
        "storage_key": "property/6767906449167194/019d0220-0e7d-762a-9e93-fdfaa83653b9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cmzoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10507210585571489614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cheyenne-mountain-zoo",
      "poi_latitude": "38.7703872",
      "poi_longitude": "-104.8548688",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 719-633-9925",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cc8-771f-a2e5-1f61654d83cb",
        "storage_key": "property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk6vByq9cE4cRTnc2pVsc0ZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_4ee984e0-24f2-4864-8fa5-4ea164539b0e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "The Broadmoor World Arena",
      "poi_type": "Entertainment",
      "poi_address": "3185 Venetucci Blvd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Arena with events such as concerts & comedy shows plus an ice hall with hockey & figure skating.",
      "poi_long_description": "Arena with events such as concerts & comedy shows plus an ice hall with hockey & figure skating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-10d4-7278-b3ec-0647980110b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-10d4-7278-b3ec-0647980110b2",
        "storage_key": "property/6767906449167194/019d0220-10d4-7278-b3ec-0647980110b2.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "http://www.broadmoorworldarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15763854442163136597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-broadmoor-world-arena",
      "poi_latitude": "38.7882819",
      "poi_longitude": "-104.7942332",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 719-477-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cc8-771f-a2e5-1f61654d83cb",
        "storage_key": "property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxfyXXn9EE4cRVegYPBh2xNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_f0d404ff-843c-42c9-8d12-d08572abaafd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Penrose Heritage Museum",
      "poi_type": "Entertainment",
      "poi_address": "11 Lake Cir, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Free-entry museum home to a philanthropist's collection of carriages, race cars & Western artifacts.",
      "poi_long_description": "Free-entry museum home to a philanthropist's collection of carriages, race cars & Western artifacts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-11f2-7272-96de-d9384fe7f909.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-11f2-7272-96de-d9384fe7f909",
        "storage_key": "property/6767906449167194/019d0220-11f2-7272-96de-d9384fe7f909.webp",
        "width": 960,
        "height": 639
      },
      "poi_business_url": "https://www.elpomar.org/About-Us/museum-and-legacy-properties/penrose-heritage-museum-1/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17537833507134891361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "penrose-heritage-museum",
      "poi_latitude": "38.7926733",
      "poi_longitude": "-104.849918",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 719-577-7065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-449a-7768-9f46-cfa491b3bb9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-449a-7768-9f46-cfa491b3bb9a",
        "storage_key": "property/6767906449167194/019d0220-449a-7768-9f46-cfa491b3bb9a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2zbOurJEE4cRYeW3wqfmYvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_94cf55a5-31d2-468e-8c8e-7d91203bcd04",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "The Broadmoor Seven Falls",
      "poi_type": "Entertainment",
      "poi_address": "1045 Lower Gold Camp Road, Colorado Springs, CO 80905, USA",
      "poi_short_description": "Park focused on scenic waterfalls & geologic monuments that also has a historic gravesite.",
      "poi_long_description": "Park focused on scenic waterfalls & geologic monuments that also has a historic gravesite.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-143e-751d-ba69-8151d41d23c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-143e-751d-ba69-8151d41d23c3",
        "storage_key": "property/6767906449167194/019d0220-143e-751d-ba69-8151d41d23c3.webp",
        "width": 736,
        "height": 491
      },
      "poi_business_url": "https://www.sevenfalls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8987375542602143609&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-broadmoor-seven-falls",
      "poi_latitude": "38.7819262",
      "poi_longitude": "-104.8799383",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 855-923-7272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cc8-771f-a2e5-1f61654d83cb",
        "storage_key": "property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmaCcQGRbE4cReZfVV3CSuXw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_2f0bc32a-1c0d-4076-aec2-fd2556488c84",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Norris Penrose Event Center",
      "poi_type": "Entertainment",
      "poi_address": "1045 Lower Gold Camp Rd, Colorado Springs, CO 80905, USA",
      "poi_short_description": "Venue that hosts rodeos, monster trucks, and other events, along with a campground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-152b-723b-aa2d-f33406a1a9b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-152b-723b-aa2d-f33406a1a9b4",
        "storage_key": "property/6767906449167194/019d0220-152b-723b-aa2d-f33406a1a9b4.webp",
        "width": 834,
        "height": 625
      },
      "poi_business_url": "http://www.norrispenrose.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12186594009454352729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "norris-penrose-event-center",
      "poi_latitude": "38.8231803",
      "poi_longitude": "-104.8478961",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 719-635-1101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cc8-771f-a2e5-1f61654d83cb",
        "storage_key": "property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJITd9sipFE4cRWRluK696H6k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_aa37731c-c4eb-4daa-9930-85b1b44c5bf5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "UCHealth Memorial Hospital Central",
      "poi_type": "Health and Wellness",
      "poi_address": "1400 E Boulder St, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-1667-7616-bc6b-22e579bfe5f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-1667-7616-bc6b-22e579bfe5f5",
        "storage_key": "property/6767906449167194/019d0220-1667-7616-bc6b-22e579bfe5f5.webp",
        "width": 1250,
        "height": 781
      },
      "poi_business_url": "https://www.uchealth.org/locations/uchealth-memorial-hospital-central/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13025990946729059480&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uchealth-memorial-hospital-central",
      "poi_latitude": "38.8402512",
      "poi_longitude": "-104.7991331",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 719-365-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-44c4-7567-9c0e-76793c338c1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-44c4-7567-9c0e-76793c338c1d",
        "storage_key": "property/6767906449167194/019d0220-44c4-7567-9c0e-76793c338c1d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLcNT_3JFE4cRmGQ9W8CdxbQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c55fe3e6-74b9-4db6-ab85-6cd21073c3a5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Rocky Mountain Health Care Services",
      "poi_type": "Health and Wellness",
      "poi_address": "2502 E Pikes Peak Ave #400, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-1739-73b7-82a3-fe87cf91e0a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-1739-73b7-82a3-fe87cf91e0a6",
        "storage_key": "property/6767906449167194/019d0220-1739-73b7-82a3-fe87cf91e0a6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rmhcare.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10506680595021024240&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rocky-mountain-health-care-services",
      "poi_latitude": "38.8334672",
      "poi_longitude": "-104.7843488",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 719-314-2327",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cc8-771f-a2e5-1f61654d83cb",
        "storage_key": "property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCQZjTbJFE4cR8Mu3mlU6z5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_7ae3232a-0563-42e2-8d96-6a2360196dc2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "EmergiCare",
      "poi_type": "Health and Wellness",
      "poi_address": "402 W Bijou St, Colorado Springs, CO 80905, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-19b3-722a-bd0b-0fe125350e3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-19b3-722a-bd0b-0fe125350e3e",
        "storage_key": "property/6767906449167194/019d0220-19b3-722a-bd0b-0fe125350e3e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.emergi-care.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2691533860817553377&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emergicare",
      "poi_latitude": "38.8372865",
      "poi_longitude": "-104.8330066",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 719-302-6942",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cc8-771f-a2e5-1f61654d83cb",
        "storage_key": "property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOfeKbzpFE4cR4Uf3Osk_WiU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_32bae277-97e2-488a-a630-f07228eccdfc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Colorado Springs Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2224 E Pikes Peak Ave, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-1a3a-75fd-a75b-c4342b604d87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-1a3a-75fd-a75b-c4342b604d87",
        "storage_key": "property/6767906449167194/019d0220-1a3a-75fd-a75b-c4342b604d87.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4311112564581279464&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colorado-springs-pharmacy",
      "poi_latitude": "38.8332143",
      "poi_longitude": "-104.7890128",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 719-428-2003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-456f-7460-8f5d-eddf43c8fc65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-456f-7460-8f5d-eddf43c8fc65",
        "storage_key": "property/6767906449167194/019d0220-456f-7460-8f5d-eddf43c8fc65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYf7vuq1FE4cR6CaXRgkm1Ds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_0d25c005-88c6-420b-8640-e2fb8a0daa39",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Walgreens Specialty Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "15 N Union Blvd, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-1bc3-748a-bb11-601609a3845a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-1bc3-748a-bb11-601609a3845a",
        "storage_key": "property/6767906449167194/019d0220-1bc3-748a-bb11-601609a3845a.webp",
        "width": 577,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-15+n+union+blvd-colorado+springs-co-80909/id=16531",
      "poi_directions_map_url": "https://maps.google.com/?cid=10028575931402517486&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-specialty-pharmacy",
      "poi_latitude": "38.8335465",
      "poi_longitude": "-104.7941302",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 719-452-4356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-456f-7460-8f5d-eddf43c8fc65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-456f-7460-8f5d-eddf43c8fc65",
        "storage_key": "property/6767906449167194/019d0220-456f-7460-8f5d-eddf43c8fc65.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC6ro5qtFE4cR7ntHCq2oLIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_2efa2e29-c715-4209-af02-fded82a5022b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Cambio Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "1604 Pikes Peak Ave, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Variety of yoga classes offered at this studio with a homey vibe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-1cfa-73b3-801c-c6bbd4a92622.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-1cfa-73b3-801c-c6bbd4a92622",
        "storage_key": "property/6767906449167194/019d0220-1cfa-73b3-801c-c6bbd4a92622.webp",
        "width": 918,
        "height": 867
      },
      "poi_business_url": "http://www.cambioyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4069552349415708542&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cambio-yoga",
      "poi_latitude": "38.8334199",
      "poi_longitude": "-104.7974225",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 719-229-1188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-4137-76be-ad57-03b9e9e0cfb4",
        "storage_key": "property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVxr2k4RFE4cRfpfH5Uz0eTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_ddcff65a-3096-4b03-8b18-ed1bf4cd79f1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Iron Wild Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "325 E Pikes Peak Ave, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3573389226904635705&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "iron-wild-fitness",
      "poi_latitude": "38.8334852",
      "poi_longitude": "-104.8189109",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cc8-771f-a2e5-1f61654d83cb",
        "storage_key": "property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv-sYJABFE4cROcnbuZE6lzE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d6a9b384-c6fb-4abe-a04b-7ebbc39d9a52",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Downtown YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "207 N Nevada Ave, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-1eee-705b-b0bd-d4d10fe9545d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-1eee-705b-b0bd-d4d10fe9545d",
        "storage_key": "property/6767906449167194/019d0220-1eee-705b-b0bd-d4d10fe9545d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ppymca.org/location/downtown-ymca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14946895381681272175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-ymca",
      "poi_latitude": "38.8370859",
      "poi_longitude": "-104.8212558",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 719-473-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cc8-771f-a2e5-1f61654d83cb",
        "storage_key": "property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnWgawxdFE4cRb_UJWCgKbs8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_72280ffd-68da-499f-a3f6-cf022f557876",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Core Collective",
      "poi_type": "Health and Wellness",
      "poi_address": "25 N Wahsatch Ave Ste 202, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-1f60-739e-9b6a-5a0c647bdccd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-1f60-739e-9b6a-5a0c647bdccd",
        "storage_key": "property/6767906449167194/019d0220-1f60-739e-9b6a-5a0c647bdccd.webp",
        "width": 1224,
        "height": 816
      },
      "poi_business_url": "http://corecollectivecos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1123279140057676386&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "core-collective",
      "poi_latitude": "38.8348854",
      "poi_longitude": "-104.8176919",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 719-301-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-4137-76be-ad57-03b9e9e0cfb4",
        "storage_key": "property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPwdr8dtFE4cRYnq-Lm2wlg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a0c81aec-3d73-423a-b1c5-10157f7153f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1605 E Pikes Peak Ave, Colorado Springs, CO 80910, USA",
      "poi_short_description": "Lakeside park with swimming & boating plus sports facilities such as a velodrome & tennis courts.",
      "poi_long_description": "Lakeside park with swimming & boating plus sports facilities such as a velodrome & tennis courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-072e-7428-9591-7680bd638f4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-072e-7428-9591-7680bd638f4f",
        "storage_key": "property/6767906449167194/019d0220-072e-7428-9591-7680bd638f4f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://coloradosprings.gov/memorialpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=5762717626599099076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-park",
      "poi_latitude": "38.8316658",
      "poi_longitude": "-104.7994188",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-4487-723d-a4ac-bedc16c68f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-4487-723d-a4ac-bedc16c68f99",
        "storage_key": "property/6767906449167194/019d0220-4487-723d-a4ac-bedc16c68f99.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJG_sToXJEE4cRxEpSMiZJ-U8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f7fa74f4-e156-49f6-9e72-c614a7ff7bc2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Prospect Lake Beach",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "619 Prospect Lake Dr, Colorado Springs, CO 80910, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-2169-71de-9267-aefea0288916.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-2169-71de-9267-aefea0288916",
        "storage_key": "property/6767906449167194/019d0220-2169-71de-9267-aefea0288916.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3246381651077438715&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prospect-lake-beach",
      "poi_latitude": "38.8246662",
      "poi_longitude": "-104.8011822",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 719-200-5010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cc8-771f-a2e5-1f61654d83cb",
        "storage_key": "property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRUm6Gv9EE4cR-xzRXel2DS0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4f46d994-4198-47cc-89b1-a90c822f64e3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Palmer Park Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3650 Maizeland Rd, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Mountain-like terrain with trails winding through scrub brush, pines and cacti.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-21b6-741f-9540-bb6fc6814145.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-21b6-741f-9540-bb6fc6814145",
        "storage_key": "property/6767906449167194/019d0220-21b6-741f-9540-bb6fc6814145.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11076527494439290367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palmer-park-trailhead",
      "poi_latitude": "38.8678562",
      "poi_longitude": "-104.7616803",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-4487-723d-a4ac-bedc16c68f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-4487-723d-a4ac-bedc16c68f99",
        "storage_key": "property/6767906449167194/019d0220-4487-723d-a4ac-bedc16c68f99.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo0WMOfpFE4cR_8Xm-hG7t5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b03e94fe-39e7-4fa1-8ac6-956a68407e4f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Acacia Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "115 E Platte Ave, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Small community green space with picnic tables, a playground, horseshoe pits & walking paths.",
      "poi_long_description": "Small community green space with picnic tables, a playground, horseshoe pits & walking paths.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-24e4-740c-9b9f-43491240249e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-24e4-740c-9b9f-43491240249e",
        "storage_key": "property/6767906449167194/019d0220-24e4-740c-9b9f-43491240249e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://coloradosprings.gov/parks-recreation-and-cultural-services/page/neighborhood-parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=12240621140338346222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "acacia-park",
      "poi_latitude": "38.8373553",
      "poi_longitude": "-104.8224447",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 719-385-5940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-4487-723d-a4ac-bedc16c68f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-4487-723d-a4ac-bedc16c68f99",
        "storage_key": "property/6767906449167194/019d0220-4487-723d-a4ac-bedc16c68f99.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJH4-pfD1FE4cR7ggB1BJs36k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4b96b98d-e0bf-40f6-9f94-172c0b441187",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "America the Beautiful Park Fantasy Playground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "126 Cimino Dr, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Intimate community park featuring a contemporary water fountain sculpture at its center.",
      "poi_long_description": "Intimate community park featuring a contemporary water fountain sculpture at its center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-249e-761c-94bf-6312ed0d84cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-249e-761c-94bf-6312ed0d84cd",
        "storage_key": "property/6767906449167194/019d0220-249e-761c-94bf-6312ed0d84cd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://coloradosprings.gov/parks/page/america-beautiful-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17887853637507382168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "america-the-beautiful-park-fantasy-playground",
      "poi_latitude": "38.8309339",
      "poi_longitude": "-104.8317651",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 719-385-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cc8-771f-a2e5-1f61654d83cb",
        "storage_key": "property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF1r6uiVFE4cRmHvOARxsPvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "playground"
    },
    {
      "id": "custom_219ec450-a995-485b-8b69-4c75175a5f46",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Monument Valley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "170 W Cache La Poudre St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Century-old park with ballfields & paths for running & cycling, plus a pool & formal gardens.",
      "poi_long_description": "Century-old park with ballfields & paths for running & cycling, plus a pool & formal gardens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-272f-757e-b5cc-1e1a1c43d7e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-272f-757e-b5cc-1e1a1c43d7e3",
        "storage_key": "property/6767906449167194/019d0220-272f-757e-b5cc-1e1a1c43d7e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://coloradosprings.gov/parks/page/monument-valley-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13621370286329543394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "monument-valley-park",
      "poi_latitude": "38.8465688",
      "poi_longitude": "-104.8280831",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-4487-723d-a4ac-bedc16c68f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-4487-723d-a4ac-bedc16c68f99",
        "storage_key": "property/6767906449167194/019d0220-4487-723d-a4ac-bedc16c68f99.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9yQ_YURFE4cR4rq7NhvUCL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f0ec7266-40db-4504-8755-3ecbe52d10b5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Garden of the Gods Visitor & Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1805 N 30th St, Colorado Springs, CO 80904, USA",
      "poi_short_description": "Rock-climbing spot featuring trails, sandstone formations and vistas, along with a park-history museum.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-0e49-76bf-813f-4fe3d3e7f46b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-0e49-76bf-813f-4fe3d3e7f46b",
        "storage_key": "property/6767906449167194/019d0220-0e49-76bf-813f-4fe3d3e7f46b.webp",
        "width": 1280,
        "height": 334
      },
      "poi_business_url": "https://gardenofgods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6587710856062110015&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garden-of-the-gods-visitor--nature-center",
      "poi_latitude": "38.8783986",
      "poi_longitude": "-104.8697704",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 719-634-6666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cc8-771f-a2e5-1f61654d83cb",
        "storage_key": "property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6oa22pQE4cRPwmR0h5AbFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_10408c16-17eb-41b6-bb79-558a06627039",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Red Rock Canyon",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3550 W High St, Colorado Springs, CO 80904, USA",
      "poi_short_description": "City preserve with marked walking & biking trails, as well as scenic views of red-rock formations.",
      "poi_long_description": "City preserve with marked walking & biking trails, as well as scenic views of red-rock formations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-26cb-7179-9366-14911c84eb39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-26cb-7179-9366-14911c84eb39",
        "storage_key": "property/6767906449167194/019d0220-26cb-7179-9366-14911c84eb39.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://redrockcanyonopenspace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15444699715466012842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-rock-canyon",
      "poi_latitude": "38.8518656",
      "poi_longitude": "-104.8784924",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 719-385-5940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cc8-771f-a2e5-1f61654d83cb",
        "storage_key": "property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm4OCqpxaE4cRqqjtyo-YVtY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_905c2a50-209c-4536-a6a0-8be070bdd3b3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Bear Creek Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "245 Bear Creek Rd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Wildlife, nature trails & a variety of habitats featured at a preserve with guided tours & events.",
      "poi_long_description": "Wildlife, nature trails & a variety of habitats featured at a preserve with guided tours & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-2a74-741f-9f59-b9d65d7c9705.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-2a74-741f-9f59-b9d65d7c9705",
        "storage_key": "property/6767906449167194/019d0220-2a74-741f-9f59-b9d65d7c9705.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://communityservices.elpasoco.com/nature-centers/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9643867229157335752&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-creek-nature-center",
      "poi_latitude": "38.8294281",
      "poi_longitude": "-104.878664",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 719-520-6387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-4137-76be-ad57-03b9e9e0cfb4",
        "storage_key": "property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6SAIlOVaE4cRyCL0Ribm1YU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_36cd486c-3578-41ac-ac9a-5768243a5d39",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Patty Jewett Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "900 E Espanola St, Colorado Springs, CO 80907, USA",
      "poi_short_description": "Historical golf complex featuring an 18-hole course & a 9-hole course, plus a shop & an eatery.",
      "poi_long_description": "Historical golf complex featuring an 18-hole course & a 9-hole course, plus a shop & an eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-2b20-71f2-a50e-ee4ee0315cd7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-2b20-71f2-a50e-ee4ee0315cd7",
        "storage_key": "property/6767906449167194/019d0220-2b20-71f2-a50e-ee4ee0315cd7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://coloradosprings.gov/pattyjewett",
      "poi_directions_map_url": "https://maps.google.com/?cid=14758230452987073676&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "patty-jewett-golf-course",
      "poi_latitude": "38.8591667",
      "poi_longitude": "-104.8025",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 719-385-6934",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-47c9-7088-a26e-be49fce47abc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-47c9-7088-a26e-be49fce47abc",
        "storage_key": "property/6767906449167194/019d0220-47c9-7088-a26e-be49fce47abc.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJI1-h1HlFE4cRjJSlj2fEz8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_be5f9c39-e36a-43dc-82a0-c103bde6bf31",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Pikes Peak/Circle",
      "poi_type": "Transportation & Transit",
      "poi_address": "Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8303662107506294185&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pikes-peakcircle",
      "poi_latitude": "38.83265",
      "poi_longitude": "-104.77495",
      "poi_miles_from_property": "0.00",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cc8-771f-a2e5-1f61654d83cb",
        "storage_key": "property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt5OrmMpFE4cRqb3ILLGIPHM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_92706c05-2ba9-4667-9fbb-e094768630fe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Pikes Peak/Union",
      "poi_type": "Transportation & Transit",
      "poi_address": "Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16273431749510991880&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pikes-peakunion",
      "poi_latitude": "38.83291",
      "poi_longitude": "-104.79557",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cc8-771f-a2e5-1f61654d83cb",
        "storage_key": "property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq4Q9zKtFE4cRCJAqsvTX1uE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_63059364-99c5-4b0c-b9e1-46e17de522f0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Metro Downtown Bus Terminal",
      "poi_type": "Transportation & Transit",
      "poi_address": "127 E Kiowa St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-2c4e-737d-bebd-63c4ec66ae37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-2c4e-737d-bebd-63c4ec66ae37",
        "storage_key": "property/6767906449167194/019d0220-2c4e-737d-bebd-63c4ec66ae37.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16550523255779328766&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "metro-downtown-bus-terminal",
      "poi_latitude": "38.834925",
      "poi_longitude": "-104.8220235",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 719-385-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cc8-771f-a2e5-1f61654d83cb",
        "storage_key": "property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDABxhFE4cR_oKRczZFr-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_f072577d-cff4-4443-a0cb-76fa0f284513",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Woodmen Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "6910 Mark Dabling Blvd, Colorado Springs, CO 80919, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-2cd4-763e-9038-d87301ce9f61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-2cd4-763e-9038-d87301ce9f61",
        "storage_key": "property/6767906449167194/019d0220-2cd4-763e-9038-d87301ce9f61.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3052945528737043137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodmen-park-and-ride",
      "poi_latitude": "38.9321944",
      "poi_longitude": "-104.8155446",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 719-385-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-47ef-77e8-9af5-28b2b5d2938d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-47ef-77e8-9af5-28b2b5d2938d",
        "storage_key": "property/6767906449167194/019d0220-47ef-77e8-9af5-28b2b5d2938d.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8OsQmlOE4cRwRL9fsg9Xio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_4b9316b1-394c-4bd5-9e2d-7ade061ea53d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Tejon Park-n-Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "S Tejon St & Ronald Reagan H, Colorado Springs, CO 80905, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-2ef6-7119-ba9f-6c499096a6ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-2ef6-7119-ba9f-6c499096a6ad",
        "storage_key": "property/6767906449167194/019d0220-2ef6-7119-ba9f-6c499096a6ad.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3764909945155561880&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tejon-park-n-ride",
      "poi_latitude": "38.815306",
      "poi_longitude": "-104.8232167",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-47ef-77e8-9af5-28b2b5d2938d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-47ef-77e8-9af5-28b2b5d2938d",
        "storage_key": "property/6767906449167194/019d0220-47ef-77e8-9af5-28b2b5d2938d.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJK7ZxttxEE4cRmClV1KWlPzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_a2f2904f-9cdc-41f0-8061-0d8c3c605bcc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Voyager Transfer Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Colorado Springs, CO 80920, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6965618429103935134&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "voyager-transfer-station",
      "poi_latitude": "38.95033",
      "poi_longitude": "-104.80148",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "4 hours 0 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-4820-71cb-b631-d33f22975bd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-4820-71cb-b631-d33f22975bd0",
        "storage_key": "property/6767906449167194/019d0220-4820-71cb-b631-d33f22975bd0.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJz7AmgX9OE4cRno6nSw7ZqmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_c8b3ed3c-ef16-49c8-806c-5fe9ddc13ec1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Mountain Metropolitan Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "1015 Transit Dr, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-2fd5-76e3-97be-dfc6027bf891.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-2fd5-76e3-97be-dfc6027bf891",
        "storage_key": "property/6767906449167194/019d0220-2fd5-76e3-97be-dfc6027bf891.webp",
        "width": 1280,
        "height": 1279
      },
      "poi_business_url": "http://mmtransit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=722502473995738549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mountain-metropolitan-transit",
      "poi_latitude": "38.8189618",
      "poi_longitude": "-104.8050417",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 719-385-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-48ae-7148-93c4-356cacf46b6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-48ae-7148-93c4-356cacf46b6a",
        "storage_key": "property/6767906449167194/019d0220-48ae-7148-93c4-356cacf46b6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpZnOIvpEE4cRtV3bDyzYBgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_b661ab9b-a543-42a3-ae22-ab1a59943e9d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Colorado Springs Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "7770 Milton E Proby Pkwy, Colorado Springs, CO 80916, USA",
      "poi_short_description": "This municipal airport featuring permanent & rotating art exhibitions also offers free WiFi.",
      "poi_long_description": "This municipal airport featuring permanent & rotating art exhibitions also offers free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3131-7031-b05c-4715234ac01c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-3131-7031-b05c-4715234ac01c",
        "storage_key": "property/6767906449167194/019d0220-3131-7031-b05c-4715234ac01c.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.flycos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5054110453719476621&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colorado-springs-airport",
      "poi_latitude": "38.8036959",
      "poi_longitude": "-104.7112051",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 719-550-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-4b71-761e-bc3e-df23b3e01212.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-4b71-761e-bc3e-df23b3e01212",
        "storage_key": "property/6767906449167194/019d0220-4b71-761e-bc3e-df23b3e01212.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJdQvRTypHE4cRjamJCa7OI0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_8cb8795a-0f5e-4cbd-82d4-961ea3a9eae7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "CommonSpirit Penrose Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2222 N Nevada Ave, Colorado Springs, CO 80907, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-30ea-725c-801c-f212d1e3ecfc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-30ea-725c-801c-f212d1e3ecfc",
        "storage_key": "property/6767906449167194/019d0220-30ea-725c-801c-f212d1e3ecfc.webp",
        "width": 800,
        "height": 551
      },
      "poi_business_url": "https://www.mountain.commonspirit.org/location/penrose-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=16350633166847560439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "commonspirit-penrose-hospital",
      "poi_latitude": "38.8655367",
      "poi_longitude": "-104.821745",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 719-776-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-44c4-7567-9c0e-76793c338c1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-44c4-7567-9c0e-76793c338c1d",
        "storage_key": "property/6767906449167194/019d0220-44c4-7567-9c0e-76793c338c1d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJAd9SD2BFE4cR90qrYjwe6eI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_741bf4af-4260-49c4-a543-734e1e987e7a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "CommonSpirit St. Francis Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6001 E Woodmen Rd, Colorado Springs, CO 80923, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-33ed-70ed-a990-a0f0beca9f6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-33ed-70ed-a990-a0f0beca9f6b",
        "storage_key": "property/6767906449167194/019d0220-33ed-70ed-a990-a0f0beca9f6b.webp",
        "width": 800,
        "height": 541
      },
      "poi_business_url": "https://www.mountain.commonspirit.org/location/st-francis-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=563675664560452527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "commonspirit-st-francis-hospital",
      "poi_latitude": "38.9382588",
      "poi_longitude": "-104.7173539",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 55 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 719-571-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-44c4-7567-9c0e-76793c338c1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-44c4-7567-9c0e-76793c338c1d",
        "storage_key": "property/6767906449167194/019d0220-44c4-7567-9c0e-76793c338c1d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJmVwCfxJJE4cRr3OoygeU0gc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_b30f3900-629b-4a7c-8f3e-66bca5edf47b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Children's Hospital Colorado, Colorado Springs",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4090 Briargate Pkwy, Colorado Springs, CO 80920, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3405-73df-a634-4902629f96bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-3405-73df-a634-4902629f96bb",
        "storage_key": "property/6767906449167194/019d0220-3405-73df-a634-4902629f96bb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.childrenscolorado.org/locations/colorado-springs-hospital/?slid=org_soc&utm_source=google&utm_medium=extlist&utm_campaign=locations&utm_id=chccs",
      "poi_directions_map_url": "https://maps.google.com/?cid=446600458676907134&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-hospital-colorado-colorado-springs",
      "poi_latitude": "38.9681706",
      "poi_longitude": "-104.7542615",
      "poi_miles_from_property": "11.6",
      "poi_walking_minutes": "4 hours 30 mins",
      "poi_biking_minutes": "1 hour 53 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 719-305-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-44c4-7567-9c0e-76793c338c1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-44c4-7567-9c0e-76793c338c1d",
        "storage_key": "property/6767906449167194/019d0220-44c4-7567-9c0e-76793c338c1d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJgYnBwrtNE4cRfqz2P8CkMgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d0dda2f3-421c-438a-a88d-5ffbbd5c4cf5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Peterson SFB Visitor Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "80916, 1334 W Stewart Ave, Colorado Springs, CO 80914, USA",
      "poi_short_description": "Visitor center offering free admission and processing base entry badges.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-351d-74fa-a6be-1a0e57214dca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-351d-74fa-a6be-1a0e57214dca",
        "storage_key": "property/6767906449167194/019d0220-351d-74fa-a6be-1a0e57214dca.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.peterson.af.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5291928981150453039&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peterson-sfb-visitor-center",
      "poi_latitude": "38.8318662",
      "poi_longitude": "-104.7087446",
      "poi_miles_from_property": "13",
      "poi_walking_minutes": "4 hours 52 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 719-556-6660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cc8-771f-a2e5-1f61654d83cb",
        "storage_key": "property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIx9R-fxGE4cRL00R2l61cEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_c3c6544e-0240-46e8-a646-494888cd120a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Schriever Space Force Base Visitor Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1560 Enoch Rd, Colorado Springs, CO 80930, USA",
      "poi_short_description": "Visitor center providing free admission, with helpful staff.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.spacebasedelta1.spaceforce.mil/Schriever-SFB-Colorado/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12504728080446435209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "schriever-space-force-base-visitor-center",
      "poi_latitude": "38.8162375",
      "poi_longitude": "-104.5364131",
      "poi_miles_from_property": "27.3",
      "poi_walking_minutes": "10 hours 2 mins",
      "poi_biking_minutes": "2 hours 17 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 719-567-5620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-3cc8-771f-a2e5-1f61654d83cb",
        "storage_key": "property/6767906449167194/019d0220-3cc8-771f-a2e5-1f61654d83cb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb2NITHE8E4cRia_cr--3ia0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_9d76dd1e-2b32-415d-959d-b89e3a2d8af0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Fort Carson ACS Center (Army Community Service)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6303 Wetzel Ave Building 1526, Fort Carson, CO 80913, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-35a6-7229-9318-108070591e89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-35a6-7229-9318-108070591e89",
        "storage_key": "property/6767906449167194/019d0220-35a6-7229-9318-108070591e89.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://carson.armymwr.com/ACS",
      "poi_directions_map_url": "https://maps.google.com/?cid=1044166838443651716&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-carson-acs-center-army-community-service",
      "poi_latitude": "38.7409199",
      "poi_longitude": "-104.7902457",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 719-526-4590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-48ae-7148-93c4-356cacf46b6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-48ae-7148-93c4-356cacf46b6a",
        "storage_key": "property/6767906449167194/019d0220-48ae-7148-93c4-356cacf46b6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz_2ZKFVCE4cRhDKtEzWgfQ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_dc72f462-afaf-4cd8-8d14-a1803816e77b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "United States Air Force Academy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2354 Fairchild Dr Suite 3A15, Air Force Academy, CO 80840, USA",
      "poi_short_description": "Founded in 1954, this famed facility provides training to U.S. Air Force cadets & features exhibits.",
      "poi_long_description": "Founded in 1954, this famed facility provides training to U.S. Air Force cadets & features exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3855-726b-8a7d-eb7a048ad4fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-3855-726b-8a7d-eb7a048ad4fc",
        "storage_key": "property/6767906449167194/019d0220-3855-726b-8a7d-eb7a048ad4fc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.usafa.af.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7058847335799811890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "united-states-air-force-academy",
      "poi_latitude": "38.9928377",
      "poi_longitude": "-104.8582914",
      "poi_miles_from_property": "14.6",
      "poi_walking_minutes": "5 hours 32 mins",
      "poi_biking_minutes": "1 hour 39 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 719-333-2025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-4137-76be-ad57-03b9e9e0cfb4",
        "storage_key": "property/6767906449167194/019d0220-4137-76be-ad57-03b9e9e0cfb4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtVAcXNhSE4cRMm8PpkAQ9mE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_3f45e95a-e7ba-48ac-be59-ab57655e9ec7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "custom",
      "poi_name": "Cheyenne Mountain Space Force Station",
      "poi_type": "Major Employers & Offices",
      "poi_address": "101, Norad Rd #1, Colorado Springs, CO 80906, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-3876-724b-95ec-8e9eea9fc310.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-3876-724b-95ec-8e9eea9fc310",
        "storage_key": "property/6767906449167194/019d0220-3876-724b-95ec-8e9eea9fc310.webp",
        "width": 1280,
        "height": 889
      },
      "poi_business_url": "http://www.norad.mil/AboutNORAD/CheyenneMountainAirForceStation.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=308042707871460001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cheyenne-mountain-space-force-station",
      "poi_latitude": "38.7441348",
      "poi_longitude": "-104.8459048",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "4 hours 18 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 719-474-1110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019d0220-48ae-7148-93c4-356cacf46b6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-48ae-7148-93c4-356cacf46b6a",
        "storage_key": "property/6767906449167194/019d0220-48ae-7148-93c4-356cacf46b6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFdhPzCBDE4cRoepT8jVjRgQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    }
  ],
  "office_hours": [
    {
      "id": "ec_935db786aaf539b35806f974",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_6963c053e0500744fe96cea1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_131dc8114466792fd0b1fb76",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_d2d708a2bbdb03ae9a2f8444",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e5e6ea0d1323ea58736bc95b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_08002d507d21c5d785603bda",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "rating": "5",
      "name": "Jess Stidham",
      "text": "We've been living here since December of 2025 and absolutely love it! If you're a little late on the rent, they're very understanding and compassionate about helping you find some rental assistance. Ms Jamie is absolutely amazing and I adore her! Definitely recommend Copperstone Apartments!!!!",
      "date": "2026-03-05",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_37174b3a1556d9432cca53d4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019ddcf9-3a37-777c-b986-7f1a02d402e4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcf9-3a37-777c-b986-7f1a02d402e4",
        "storage_key": "property/6767906449167194/019ddcf9-3a37-777c-b986-7f1a02d402e4.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Studio",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=cymRoAcZFg5"
    },
    {
      "id": "ec_4c2a4528e12041b2b3de16e3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019ddcf9-3a2e-754e-9100-40f157e10b61.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcf9-3a2e-754e-9100-40f157e10b61",
        "storage_key": "property/6767906449167194/019ddcf9-3a2e-754e-9100-40f157e10b61.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1 Bedroom",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=VB7DcxVum8q"
    },
    {
      "id": "ec_a431bb9b0b7e5ea03dc75660",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019ddcf9-391c-73b2-83b0-be62298543ea.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcf9-391c-73b2-83b0-be62298543ea",
        "storage_key": "property/6767906449167194/019ddcf9-391c-73b2-83b0-be62298543ea.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2 Bedroom 1.5 bath",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=nMBpW6DFNiU"
    },
    {
      "id": "ec_b6e05a71d3239b9366411027",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167194/019ddcf9-393e-777f-9ceb-c8c543980de5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcf9-393e-777f-9ceb-c8c543980de5",
        "storage_key": "property/6767906449167194/019ddcf9-393e-777f-9ceb-c8c543980de5.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2 Bedroom 2 Bath",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=sjXeKmU24vZ"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0b0d0-76be-73ab-af15-86662bf51d3b",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Copper Stone Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-dog-park-se-colorado-springs",
      "search_query": "pet friendly apartments with dog park southeast Colorado Springs",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Dog Park",
      "h2_subtitle": "Explore our pet-friendly apartments with a dedicated dog park in Southeast Colorado Springs. Enjoy a warm community and lush greenery.",
      "page_copy": "Copper Stone Apartment Homes in Southeast Colorado Springs offers the perfect abode for pet lovers. Our pet-friendly apartments come with a delightful dog park where your furry friends can play freely. Situated in a relaxed and elegant environment, these modern living spaces ensure comfort and convenience with amenities like air conditioning, laundry facilities, and covered parking. \n\nLocated in the heart of El Paso County, Copper Stone ensures you enjoy not just a home but a community. The serene Park Hill neighborhood provides easy access to public transportation and I-25, making city life hassle-free. With ample green spaces, including a dedicated area for your pets, you'll find that Copper Stone is more than just a place to live—it's a place to belong.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, lamp, and artwork, with a sliding glass door leading to a balcony.",
        "public_id": "019d021f-5be9-706f-a000-55c2b088e3d7",
        "storage_key": "property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Dog Park",
      "seo_description": "Discover pet-friendly apartments with a dog park in Southeast Colorado Springs at Copper Stone. Enjoy modern living with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "generator",
      "page_item_url": "modern-apartments-pool-access-colorado-springs",
      "search_query": "modern apartments with pool access in Colorado Springs",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Pool Access",
      "h2_subtitle": "Find modern apartments with pool access in Colorado Springs. Experience relaxed, elegant living at Copper Stone in Park Hill.",
      "page_copy": "Discover the modern lifestyle you've been seeking at Copper Stone Apartment Homes in Colorado Springs, where pool access is just one of the many luxurious amenities we offer. Our contemporary apartments are designed for those who desire both style and convenience, with features like air conditioning and private patios or balconies.\n\nNestled in the idyllic Park Hill neighborhood, our community is perfect for those who appreciate both comfort and accessibility. Enjoy the added perks of being within reach of public transportation and I-25, while relaxing in the cool waters of our inviting pool. Copper Stone is not just a place to stay, but a place to thrive in the vibrant Southeast Colorado Springs area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, lamp, and artwork, with a sliding glass door leading to a balcony.",
        "public_id": "019d021f-5be9-706f-a000-55c2b088e3d7",
        "storage_key": "property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with Pool Access",
      "seo_description": "Explore modern apartments with pool access in Colorado Springs at Copper Stone. Enjoy stylish living with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "generator",
      "page_item_url": "apartments-air-conditioning-el-paso-county",
      "search_query": "apartments with air conditioning in El Paso County",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning",
      "h2_subtitle": "Discover apartments with air conditioning in El Paso County. Copper Stone offers comfort and convenience in a prime location.",
      "page_copy": "At Copper Stone Apartment Homes in El Paso County, air conditioning is one of the essential comforts that enhance your living experience. Situated in Southeast Colorado Springs, our modern apartments ensure you stay cool throughout the hot Colorado summers while enjoying the perfect blend of style and convenience.\n\nEmbrace the relaxed yet elegant atmosphere of the Park Hill neighborhood, complete with amenities like a swimming pool, covered parking, and pet-friendly living. Easily accessible from I-25 and close to public transportation, Copper Stone offers a community-oriented environment perfect for those seeking convenience without sacrificing quality. Choose Copper Stone for a lifestyle where comfort comes standard.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, lamp, and artwork, with a sliding glass door leading to a balcony.",
        "public_id": "019d021f-5be9-706f-a000-55c2b088e3d7",
        "storage_key": "property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Air Conditioning",
      "seo_description": "Find apartments with air conditioning in El Paso County at Copper Stone. Experience modern, comfortable living with essential amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "generator",
      "page_item_url": "apartments-dishwasher-patio-balcony-80909",
      "search_query": "apartments with dishwasher and patio/balcony in 80909",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher & Patio/Balcony",
      "h2_subtitle": "Explore apartments with dishwasher and patio/balcony in the 80909 area. Copper Stone offers modern comforts in Southeast Colorado Springs.",
      "page_copy": "Copper Stone Apartment Homes, located in the heart of the 80909 area, offers unparalleled convenience with apartments equipped with dishwashers and private patios or balconies. These features are part of our commitment to modern living, allowing residents to enjoy each moment with ease and comfort.\n\nOur community in Southeast Colorado Springs provides an elegant backdrop of relaxed living with amenities such as a refreshing pool and covered parking. Enjoy easy access to I-25 and public transport, making commuting a breeze. Copper Stone is more than just a place to live—it's a community where you can truly enjoy a sophisticated and hassle-free lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, lamp, and artwork, with a sliding glass door leading to a balcony.",
        "public_id": "019d021f-5be9-706f-a000-55c2b088e3d7",
        "storage_key": "property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher & Patio/Balcony",
      "seo_description": "Find apartments with dishwasher and patio/balcony in 80909 at Copper Stone. Enjoy a modern, comfortable lifestyle in Southeast Colorado Springs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "generator",
      "page_item_url": "convenient-covered-parking-apartments-southeast-cos",
      "search_query": "convenient covered parking apartments southeast Colorado Springs",
      "category": "Amenity",
      "h1_title": "Convenient Covered Parking Apartments",
      "h2_subtitle": "Discover apartments with convenient covered parking in Southeast Colorado Springs. Copper Stone offers modern living with prime amenities.",
      "page_copy": "Experience the ease of having convenient covered parking at Copper Stone Apartment Homes in Southeast Colorado Springs. Our community is designed to provide effortless living without compromising on style. Enjoy modern apartment amenities while knowing that your car is protected from the elements with our covered parking facilities.\n\nLocated in the welcoming neighborhood of Park Hill, Copper Stone offers pet-friendly living with easy access to public transportation and major routes like I-25. Here, you'll find a community spirit that thrives amidst modern convenience and tranquility, ensuring you have everything you need right at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, lamp, and artwork, with a sliding glass door leading to a balcony.",
        "public_id": "019d021f-5be9-706f-a000-55c2b088e3d7",
        "storage_key": "property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Convenient Covered Parking Apartments",
      "seo_description": "Explore convenient covered parking apartments in Southeast Colorado Springs at Copper Stone. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "generator",
      "page_item_url": "studio-apartments-colorado-springs",
      "search_query": "studio apartments Colorado Springs",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Colorado Springs",
      "h2_subtitle": "Explore comfortable studio apartments in Colorado Springs at Copper Stone. Experience modern amenities and a vibrant community.",
      "page_copy": "Copper Stone Apartment Homes offers cozy studio apartments in the vibrant city of Colorado Springs. Designed with modern living in mind, our studios provide a perfect blend of style and practicality, ideal for individuals seeking a simplified, yet luxurious lifestyle.\n\nNestled in the Park Hill neighborhood of Southeast Colorado Springs, Copper Stone provides easy access to I-25 and public transport, ensuring you stay connected. Enjoy on-site amenities like air conditioning, a swimming pool, and covered parking, making it the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, lamp, and artwork, with a sliding glass door leading to a balcony.",
        "public_id": "019d021f-5be9-706f-a000-55c2b088e3d7",
        "storage_key": "property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Colorado Springs",
      "seo_description": "Find comfortable studio apartments in Colorado Springs at Copper Stone. Enjoy modern living with essential amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-park-hill",
      "search_query": "1 bedroom apartments Park Hill",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Park Hill",
      "h2_subtitle": "Discover spacious 1 bedroom apartments in Park Hill at Copper Stone. Enjoy modern living with convenient amenities and community spirit.",
      "page_copy": "Copper Stone Apartment Homes invites you to explore our spacious 1 bedroom apartments located in the serene Park Hill neighborhood. Designed for modern comfort, these apartments offer a peaceful retreat in the heart of Southeast Colorado Springs. Each unit features a private patio or balcony, air conditioning, and access to on-site laundry facilities, ensuring all the comforts of home.\n\nOur community provides amenities like a refreshing pool and convenient covered parking, perfect for residents seeking a blend of relaxation and accessibility. With easy connections to I-25 and public transportation, your commute is simplified, allowing you more time to enjoy the vibrant community atmosphere of Park Hill.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, lamp, and artwork, with a sliding glass door leading to a balcony.",
        "public_id": "019d021f-5be9-706f-a000-55c2b088e3d7",
        "storage_key": "property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Park Hill",
      "seo_description": "Explore 1 bedroom apartments in Park Hill at Copper Stone, featuring modern amenities in a vibrant community. Perfect for comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-el-paso-county",
      "search_query": "2 bedroom apartments El Paso County",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in El Paso County",
      "h2_subtitle": "Find spacious 2 bedroom apartments in El Paso County at Copper Stone. Enjoy modern amenities and a welcoming community.",
      "page_copy": "At Copper Stone Apartment Homes, discover the ideal 2 bedroom apartments in El Paso County, where modern living meets community charm. Our thoughtfully designed layouts provide ample space for both relaxation and entertainment, making them perfect for families or roommates.\n\nSituated in the heart of Southeast Colorado Springs, our community offers easy access to I-25 and public transit. Enjoy on-site amenities such as a refreshing pool, covered parking, and pet-friendly living. Copper Stone combines the best of convenience and comfort, ensuring you feel right at home in El Paso County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, lamp, and artwork, with a sliding glass door leading to a balcony.",
        "public_id": "019d021f-5be9-706f-a000-55c2b088e3d7",
        "storage_key": "property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in El Paso County",
      "seo_description": "Explore 2 bedroom apartments in El Paso County at Copper Stone. Enjoy spacious living with modern amenities and convenient access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "generator",
      "page_item_url": "apartments-near-madison-elementary-colorado-springs",
      "search_query": "apartments near madison elementary school colorado springs",
      "category": "School",
      "h1_title": "Apartments Near Madison Elementary School",
      "h2_subtitle": "Discover ideal apartments near Madison Elementary School in Colorado Springs at Copper Stone. Enjoy a family-friendly environment and modern conveniences.",
      "page_copy": "Copper Stone Apartment Homes offers the ideal location for families looking for apartments near Madison Elementary School in Colorado Springs. Our community provides a conducive atmosphere for families with children, paired with modern amenities and a supportive neighborhood vibe.\n\nLocated in the Southeast Colorado Springs area, Copper Stone ensures easy access to schools, shopping, and dining. Our pet-friendly community includes amenities such as a refreshing pool, covered parking, and comfortable living spaces with air conditioning, making Copper Stone the perfect home base near Madison Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, lamp, and artwork, with a sliding glass door leading to a balcony.",
        "public_id": "019d021f-5be9-706f-a000-55c2b088e3d7",
        "storage_key": "property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Madison Elementary School",
      "seo_description": "Discover apartments near Madison Elementary School in Colorado Springs at Copper Stone. Ideal family-friendly community with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "generator",
      "page_item_url": "rentals-close-edison-elementary-southeast-co-springs",
      "search_query": "rentals close to edison elementary school in southeast colorado springs",
      "category": "School",
      "h1_title": "Rentals Near Edison Elementary School",
      "h2_subtitle": "Find rentals close to Edison Elementary School in Southeast Colorado Springs. Enjoy a convenient and family-friendly community at Copper Stone.",
      "page_copy": "Copper Stone Apartment Homes offers a perfect location for those seeking rentals close to Edison Elementary School in Southeast Colorado Springs. Our community fosters a warm, family-friendly environment, making it an ideal place for families with school-aged children.\n\nLocated conveniently near I-25, Copper Stone ensures quick commutes and easy access to everything you need in Colorado Springs. Enjoy amenities such as a swimming pool, covered parking, and spacious living areas with private patios or balconies. Our rentals provide both modern comfort and community charm, tailored for a comfortable lifestyle near Edison Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, lamp, and artwork, with a sliding glass door leading to a balcony.",
        "public_id": "019d021f-5be9-706f-a000-55c2b088e3d7",
        "storage_key": "property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Edison Elementary School",
      "seo_description": "Explore rentals near Edison Elementary School in Southeast Colorado Springs at Copper Stone. Perfect for families seeking convenience and community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "generator",
      "page_item_url": "copper-stone-apartments-near-colorado-springs-charter",
      "search_query": "copper stone apartments near colorado springs charter academy",
      "category": "School",
      "h1_title": "Copper Stone Apartments Near Charter Academy",
      "h2_subtitle": "Discover comfortable living at Copper Stone Apartments near Colorado Springs Charter Academy. Experience a welcoming community with modern amenities.",
      "page_copy": "Copper Stone Apartment Homes are conveniently located near the Colorado Springs Charter Academy, providing families with an excellent living option in the Southeast Colorado Springs area. Our modern apartments offer spacious layouts and high-end amenities, making them ideal for those seeking a balanced lifestyle.\n\nEnjoy the convenience of living close to I-25 and public transportation, ensuring easy commutes and access to local attractions. Our community features include a refreshing pool, air conditioning, and covered parking, all designed to enhance your living experience near the Charter Academy. At Copper Stone, enjoy both comfort and community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, lamp, and artwork, with a sliding glass door leading to a balcony.",
        "public_id": "019d021f-5be9-706f-a000-55c2b088e3d7",
        "storage_key": "property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Copper Stone Apartments Near Charter Academy",
      "seo_description": "Live comfortably at Copper Stone Apartments near Colorado Springs Charter Academy. Enjoy a family-friendly community and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "generator",
      "page_item_url": "apartments-near-pikes-peak-state-college-campus",
      "search_query": "apartments near pikes peak state college downtown campus",
      "category": "School",
      "h1_title": "Apartments Near Pikes Peak State College",
      "h2_subtitle": "Find your ideal home near Pikes Peak State College Downtown Campus. Live in comfort and convenience at Copper Stone Apartments.",
      "page_copy": "Copper Stone Apartment Homes offer a prime living option for students and professionals alike, located near the Downtown Campus of Pikes Peak State College. Our community presents a unique blend of modern living and everyday ease, perfect for those looking to balance their academic and social lives.\n\nResiding in Southeast Colorado Springs, Copper Stone ensures easy access to the college via public transportation and nearby highways. Enjoy community amenities such as a pool, air-conditioned units, and laundry facilities, all crafted to provide a seamless living experience close to Pikes Peak State College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, lamp, and artwork, with a sliding glass door leading to a balcony.",
        "public_id": "019d021f-5be9-706f-a000-55c2b088e3d7",
        "storage_key": "property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pikes Peak State College Campus",
      "seo_description": "Discover comfortable living near Pikes Peak State College Downtown Campus. Copper Stone Apartments offer convenience and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "generator",
      "page_item_url": "apartments-close-to-william-j-palmer-high-school",
      "search_query": "apartments close to william j palmer high school",
      "category": "School",
      "h1_title": "Apartments Close to William J Palmer High",
      "h2_subtitle": "Live conveniently near William J Palmer High School. Copper Stone Apartments provide a welcoming home in Southeast Colorado Springs.",
      "page_copy": "Copper Stone Apartment Homes present a fantastic living opportunity for families and individuals wishing to reside near William J Palmer High School. Our community is situated in Southeast Colorado Springs, making it the perfect location for students and their families seeking proximity to quality education.\n\nWith quick access to I-25 and local public transportation, getting to the high school is a breeze. Copper Stone offers amenities including a sparkling pool, air-conditioned interiors, and laundry facilities, all ensuring comfortable daily living. Experience a vibrant, friendly community environment, just a short distance from William J Palmer High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, lamp, and artwork, with a sliding glass door leading to a balcony.",
        "public_id": "019d021f-5be9-706f-a000-55c2b088e3d7",
        "storage_key": "property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to William J Palmer High",
      "seo_description": "Experience convenience at Copper Stone Apartments, located close to William J Palmer High School in Southeast Colorado Springs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "generator",
      "page_item_url": "apartments-near-colorado-college-el-paso-county",
      "search_query": "apartments near colorado college el paso county",
      "category": "School",
      "h1_title": "Apartments Near Colorado College, CO",
      "h2_subtitle": "Discover Copper Stone Apartments near Colorado College in El Paso County. Enjoy modern living close to campus and local amenities.",
      "page_copy": "Copper Stone Apartment Homes offer a superb choice for those looking to live near Colorado College in El Paso County. Nestled in Southeast Colorado Springs, our community combines stylish, modern apartments with a warm, welcoming atmosphere ideal for students and professionals alike.\n\nEnjoy easy commutes with convenient access to I-25 and public transportation, making trips to Colorado College seamless. Our community features desirable amenities such as a swimming pool, air conditioning, and covered parking, ensuring your comfort and satisfaction. Experience an engaging community lifestyle just minutes from Colorado College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, lamp, and artwork, with a sliding glass door leading to a balcony.",
        "public_id": "019d021f-5be9-706f-a000-55c2b088e3d7",
        "storage_key": "property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Colorado College, CO",
      "seo_description": "Live in style at Copper Stone Apartments near Colorado College in El Paso County. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "generator",
      "page_item_url": "rental-properties-near-uccs",
      "search_query": "rental properties near university of colorado colorado springs",
      "category": "School",
      "h1_title": "Rental Properties Near UCCS",
      "h2_subtitle": "Explore rental properties near the University of Colorado Colorado Springs. Copper Stone offers modern living with convenience.",
      "page_copy": "Copper Stone Apartment Homes present an excellent option for those seeking rental properties near the University of Colorado Colorado Springs (UCCS). Located in Southeast Colorado Springs, our community provides a peaceful retreat while keeping you close to campus life.\n\nOur apartments blend modern features with practical amenities like a pool, air conditioning, and a laundry room, perfect for students and faculty members. With easy access to public transportation and major roads, getting around the city and to UCCS is effortless. Join the welcoming Copper Stone community and enjoy a convenient lifestyle tailored to your needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, lamp, and artwork, with a sliding glass door leading to a balcony.",
        "public_id": "019d021f-5be9-706f-a000-55c2b088e3d7",
        "storage_key": "property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Properties Near UCCS",
      "seo_description": "Find the perfect rental property near UCCS at Copper Stone Apartments, featuring modern living and easy campus access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "generator",
      "page_item_url": "apartments-near-uchealth-memorial-hospital-central",
      "search_query": "apartments near UCHealth Memorial Hospital Central Colorado Springs",
      "category": "Hospital",
      "h1_title": "Apartments Near UCHealth Memorial Hospital",
      "h2_subtitle": "Discover Copper Stone Apartments near UCHealth Memorial Hospital Central in Colorado Springs. Enjoy convenience and comfort in each unit.",
      "page_copy": "Situated in Southeast Colorado Springs, Copper Stone Apartment Homes offer prime living spaces for those who work at or frequently visit UCHealth Memorial Hospital Central. Our community perfectly balances modern amenities with a homey atmosphere, just a short drive from the hospital.\n\nEnjoy the benefit of quick commutes with nearby access to major highways and public transportation. Copper Stone boasts amenities like a refreshing pool, air conditioning, and covered parking facilities, making your day-to-day living as comfortable as possible. Join a vibrant, supportive community close to UCHealth and enjoy the best of Colorado Springs living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, lamp, and artwork, with a sliding glass door leading to a balcony.",
        "public_id": "019d021f-5be9-706f-a000-55c2b088e3d7",
        "storage_key": "property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near UCHealth Memorial Hospital",
      "seo_description": "Experience modern living at Copper Stone Apartments near UCHealth Memorial Hospital Central in Colorado Springs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "generator",
      "page_item_url": "apartments-near-memorial-park-colorado-springs",
      "search_query": "apartments near Memorial Park Colorado Springs",
      "category": "Park",
      "h1_title": "Apartments Near Memorial Park, Colorado Springs",
      "h2_subtitle": "Find your perfect home at Copper Stone, close to Memorial Park in Colorado Springs. Enjoy access to nature and city conveniences.",
      "page_copy": "Copper Stone Apartment Homes are ideally located near Memorial Park in Colorado Springs, offering a blend of urban convenience and outdoor tranquility. Our community provides spacious, modern living accommodations just moments away from the scenic expanses of Memorial Park.\n\nResidents can enjoy an array of amenities, including a sparkling pool, air-conditioned units, and the convenience of on-site laundry facilities. With easy access to public transportation and nearby highways, exploring Colorado Springs and commuting to work or school is hassle-free. Discover the vibrant lifestyle at Copper Stone, perfectly positioned near Memorial Park's outdoor activities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, lamp, and artwork, with a sliding glass door leading to a balcony.",
        "public_id": "019d021f-5be9-706f-a000-55c2b088e3d7",
        "storage_key": "property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Memorial Park, Colorado Springs",
      "seo_description": "Live near Memorial Park at Copper Stone Apartments in Colorado Springs. Modern amenities with natural beauty just steps away.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "generator",
      "page_item_url": "palmer-park-trailhead-nearby-apartments-se-colorado-springs",
      "search_query": "Palmer Park Trailhead nearby apartments Southeast Colorado Springs",
      "category": "Park",
      "h1_title": "Apartments Near Palmer Park Trailhead",
      "h2_subtitle": "Explore Copper Stone Apartments, located near Palmer Park Trailhead in Southeast Colorado Springs. Enjoy nature and modern conveniences.",
      "page_copy": "Nestled in Southeast Colorado Springs, Copper Stone Apartment Homes provide an excellent living choice for those seeking residences near the Palmer Park Trailhead. Our community is not only close to nature but also offers modern comforts and conveniences.\n\nResidents enjoy easy access to the beautifully scenic trails of Palmer Park, ideal for jogging, cycling, or a leisurely stroll. At home, enjoy Air conditioning, a swimming pool, and covered parking as part of our welcoming community. With public transit and major roadways within reach, commuting and exploring the area is a breeze. Choose Copper Stone for a superb mix of active and urban living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, lamp, and artwork, with a sliding glass door leading to a balcony.",
        "public_id": "019d021f-5be9-706f-a000-55c2b088e3d7",
        "storage_key": "property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Palmer Park Trailhead",
      "seo_description": "Discover Copper Stone Apartments near Palmer Park Trailhead in Southeast Colorado Springs. Perfect blend of nature and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "generator",
      "page_item_url": "rentals-close-to-acacia-park-el-paso-county",
      "search_query": "rentals close to Acacia Park El Paso County",
      "category": "Park",
      "h1_title": "Rentals Close to Acacia Park",
      "h2_subtitle": "Find Copper Stone Apartments close to Acacia Park in El Paso County. Experience convenient, comfortable living with all your desired amenities.",
      "page_copy": "Copper Stone Apartment Homes proudly offers rentals that are conveniently located near Acacia Park in El Paso County. Enjoy a desirable mix of vibrant city life and serene community atmosphere, just a short distance from one of Colorado Springs' beloved recreational spots.\n\nOur residents relish in the variety of amenities available, from a cooling pool to modern air-conditioned units, all set in a pet-friendly environment. With quick access to public transit and major roads, commuting and enjoying the local attractions becomes effortless. Find your ideal home that places you near Acacia Park and enjoy a lifestyle rich in possibilities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, lamp, and artwork, with a sliding glass door leading to a balcony.",
        "public_id": "019d021f-5be9-706f-a000-55c2b088e3d7",
        "storage_key": "property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Acacia Park, El Paso County",
      "seo_description": "Discover Copper Stone Apartments, rentals near Acacia Park in El Paso County. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167194",
      "source": "generator",
      "page_item_url": "apartments-in-80909-near-monument-valley-park",
      "search_query": "apartments in 80909 near Monument Valley Park",
      "category": "Park",
      "h1_title": "80909 Apartments Near Monument Valley Park",
      "h2_subtitle": "Located in the 80909 zip code, Copper Stone Apartments offer proximity to Monument Valley Park, blending nature and urban living.",
      "page_copy": "Copper Stone Apartment Homes stand as a premier choice in the 80909 area, located close to the beautiful Monument Valley Park. Our outstanding community offers modern apartment living while allowing residents to enjoy the nearby natural beauty of the park.\n\nWith features such as a pool, air conditioning, and on-site laundry facilities, comfort and convenience are readily available. Our location ensures simple access to both nature trails and city conveniences, all within a pet-friendly community. Discover how Copper Stone combines the best of both worlds – the tranquility of nature and the perks of urban life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, coffee table, lamp, and artwork, with a sliding glass door leading to a balcony.",
        "public_id": "019d021f-5be9-706f-a000-55c2b088e3d7",
        "storage_key": "property/6767906449167194/019d021f-5be9-706f-a000-55c2b088e3d7.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "80909 Apartments Near Monument Valley Park",
      "seo_description": "Find Copper Stone Apartments in 80909, near Monument Valley Park. Experience a blend of nature and urban convenience in your new home.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309504375"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=7194263526"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5B5GRVV4"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "DISPO"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "86455ba1-fe55-4f81-a8a2-a9ef4ca5cf63"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Homestead"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/7663f272-a226-424b-a906-21a426037993/app.js?property=7663f272-a226-424b-a906-21a426037993&propertyName=Copper+Stone&channelUuid=c248e746-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47727335712"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InNBcHRtT1JjcjJZVTdiSzdocFAyaEE9PSIsInZhbHVlIjoiL0RPV01sNG45bjc1V055VlMvUkoxZz09IiwibWFjIjoiYmNhZTFkNjVjZDJjODI2MTQxY2Q2NzgzYzk0ZWQ1NTA1ZmI2NzYzNjcyNjAzMzk2ZjQyOTUzZDg2YTIyMTZhYSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309504375",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=7194263526",
  "custom_google_gtm_id": "GTM-5B5GRVV4",
  "custom_rollout_phase": "DISPO",
  "custom_rentgrata_token": "86455ba1-fe55-4f81-a8a2-a9ef4ca5cf63",
  "custom_vibesites_theme": "Homestead",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/7663f272-a226-424b-a906-21a426037993/app.js?property=7663f272-a226-424b-a906-21a426037993&propertyName=Copper+Stone&channelUuid=c248e746-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47727335712",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InNBcHRtT1JjcjJZVTdiSzdocFAyaEE9PSIsInZhbHVlIjoiL0RPV01sNG45bjc1V055VlMvUkoxZz09IiwibWFjIjoiYmNhZTFkNjVjZDJjODI2MTQxY2Q2NzgzYzk0ZWQ1NTA1ZmI2NzYzNjcyNjAzMzk2ZjQyOTUzZDg2YTIyMTZhYSJ9",
  "custom_audioeye_site_id": "9ecb889e-1247-4b79-bd4b-d27063d82075",
  "custom_audioeye_site_hash": "a49880b3c965c8672d9fe93a5bcf2e52"
};

export const generatedAt = '2026-10-29T23:15:37.720Z';
